// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-container{
  padding-top:.5rem
}

.results-search-form{
  position:relative
}

.results-search-form .clear-btn{
  position:absolute;
  right:.7rem;
  top:.4rem;
  font-size:1.2rem !important;
  cursor:pointer;
  color:#818a91
}

.results-search-form .clear-btn:hover{
  color:#3cdbc0
}

.search-form-examples{
  display:inline-block;
  padding:.5rem 0
}

.mobile-sidebar-container{
  position:fixed;
  top:53px;
  z-index:1080;
  right:-180px;
  transition:right .2s ease-in
}

.mobile-sidebar-trigger{
  display:inline-block;
  padding:3px 8px
}

.mobile-sidebar-trigger i.varsome-icons{
  color:#fff
}

.mobile-sidebar{
  width:180px;
  height:100%;
  background-color:#fff;
  border-left:1px solid #3cdbc0;
  border-top:1px solid #3cdbc0;
  overflow-y:scroll
}

.sidebar-link{
  padding-left:.7rem !important;
  padding-right:.5rem !important
}

.sidebar-link .tag{
  margin-top:3px
}

.sidebar-link.sidebar-gene-link{
  color:#2ca591 !important
}

.sidebar-link.sidebar-gene-link:hover{
  color:#3cdbc0 !important;
  text-decoration:underline
}

#variant-info{
  width:100%;
  background-color:rgba(90,122,160,.85);
  position:relative
}

#variant-info .mark-as-text{
  color:#fff;
  font-size:1rem;
  margin-right:.5rem
}

#variant-info .tag-pill{
  margin-left:.2rem;
  margin-right:-0.8rem;
  padding-left:.2rem
}

#variant-info .ctas-container__app .saph-white-ghost{
  opacity:.9;
  padding:4px
}

#variant-info .ctas-container__app .saph-white-ghost:hover{
  opacity:1
}

.tooltip-section-top{
  border-bottom:1px solid #999;
  color:#fff;
  margin-bottom:.2rem;
  padding-bottom:.2rem;
  display:block
}

.result-chooser{
  display:table-cell
}

.result-chooser .grouped-variants{
  display:inline-block;
  position:relative;
  border:1px dashed #fff;
  padding:.2rem .5rem;
  margin:-0.4rem 1rem .5rem 0;
  vertical-align:middle
}

.result-chooser .grouped-variants.last{
  margin-right:0
}

.result-chooser .grouped-variants a{
  font-size:16px;
  display:block;
  padding:0 .3rem
}

.result-chooser .grouped-variants a:first-child{
  margin-bottom:2px
}

.result-chooser .grouped-variants .grouped-info{
  color:#fff;
  position:absolute;
  font-size:14px;
  top:-3px;
  right:-16px
}

.result-chooser a{
  display:inline-block;
  text-align:center;
  vertical-align:middle;
  font-family:"Cabin","Helvetica Neue",Helvetica,Arial,sans-serif;
  color:#ccc;
  padding:0 1rem 0 0;
  font-size:16px !important;
  cursor:pointer;
  vertical-align:middle;
  height:100%
}

.result-chooser a.single-variant{
  margin-bottom:.5rem
}

.result-chooser a:hover{
  color:#fff
}

.result-chooser a.selected{
  color:#fff;
  font-weight:900;
  cursor:default
}

.result-chooser a.last{
  padding-right:0
}

.result-chooser .transcript-tooltip{
  color:#fff;
  margin-left:-0.8rem;
  margin-right:.8rem
}

.result-chooser .transcript-tooltip.last{
  margin-left:.2rem;
  margin-right:0
}

.btn-group{
  vertical-align:middle
}

.btn-group .btn-action{
  padding:.25rem 1rem .25rem .5rem;
  margin-right:0;
  border-radius:0;
  border-left:1px solid #fff;
  border-right:1px solid #fff
}

.btn-group .btn-action:first-child{
  border-top-left-radius:3px;
  border-bottom-left-radius:3px
}

.btn-group .btn-action:last-child{
  border-top-right-radius:3px;
  border-bottom-right-radius:3px;
  margin-right:1rem
}

.toast-container{
  position:fixed;
  width:15rem;
  max-width:300px;
  bottom:1rem;
  right:1rem;
  z-index:10101
}

.toast-container .toast{
  width:100%;
  padding:1rem 2rem 1rem 1rem;
  color:#fff;
  margin-bottom:.75rem;
  opacity:1 !important;
  background-color:rgba(0,0,0,.8) !important;
  position:relative
}

.toast-container .toast i.fa-info-circle{
  color:#729fff;
  margin-right:.5rem
}

.toast-container .toast i.fa-exclamation-circle{
  color:red;
  margin-right:.5rem
}

.toast-container .toast i.fa-check{
  color:green;
  margin-right:.5rem
}

.toast-container .toast .closeBtn{
  color:#fff;
  cursor:pointer;
  position:absolute;
  top:.5rem;
  right:.5rem
}

.toast-container .toast .closeBtn:hover{
  color:#aaa
}

.varsome-typeahead{
  position:relative;
  width:100%
}

.varsome-typeahead-input{
  width:inherit
}

.varsome-typeahead-results{
  background-color:#fff;
  z-index:10001;
  list-style-type:none;
  max-width:500px;
  margin:0;
  padding:0;
  max-height:240px;
  overflow-y:auto;
  border:1px solid #ccc
}

.varsome-typeahead-results li{
  padding:.1rem .3rem;
  cursor:pointer
}

.varsome-typeahead-results li.selected{
  background-color:#3cdbc0;
  color:#fff
}

.pubmed-form .pubmed-form-error{
  margin:1rem 0 2rem 0
}

.charts-container{
  display:flex;
  flex-wrap:wrap
}

.chart{
  flex:0 0 100%;
  border:1px solid #ddd;
  padding:5px;
  border-radius:4px;
  margin:0px 0 5px;
  position:relative;
  overflow:hidden
}

.chart .chart{
  width:100%;
  height:100%;
  margin:0 !important;
  padding:0;
  flex:1;
  border:none
}

.chart .chart .custom-container{
  width:100%;
  height:100%;
  display:flex;
  align-items:center
}

@media(min-width: 1024px){
  .chart{
    flex:0 0 calc(50% - 5px)
  }

  .chart:nth-of-type(odd){
    margin-right:5px
  }
}

@media(min-width: 1367px){
  .chart{
    padding:10px;
    margin:0px 0 10px;
    flex:0 0 calc(33% - 4px)
  }

  .chart:nth-of-type(odd){
    margin-right:0
  }

  .chart:nth-of-type(3n + 2){
    margin-left:10px;
    margin-right:10px
  }
}

.chart canvas{
  width:100%;
  height:auto;
  display:block
}

.chart--vertical{
  width:100%;
  height:auto
}

.chart--empty{
  width:200px;
  height:160px;
  display:flex;
  justify-content:center;
  flex-direction:column;
  background-color:#f7f7f7;
  padding:0 20px;
  text-align:center;
  margin:0 auto
}

.chart--empty *{
  color:#577396
}

.chart--empty i{
  font-size:1.8rem;
  display:flex;
  justify-content:center;
  color:#577396
}

.chart--empty p{
  padding:1rem 0 0 0;
  color:#577396
}

.chart--empty .emphasize{
  font-weight:600;
  color:#4e6075
}

.chart--premium{
  width:200px;
  height:160px;
  display:flex;
  justify-content:center;
  flex-direction:column;
  background-color:#f7f7f7;
  padding:0 20px;
  text-align:center;
  margin:0 auto
}

.chart--premium *{
  color:#2ca591
}

.chart--premium i{
  font-size:1.8rem;
  display:flex;
  justify-content:center;
  color:#2ca591
}

.chart--premium p{
  padding:1rem 0 0 0;
  color:#000
}

.chart--premium .emphasize{
  font-weight:600;
  color:#000
}

.hidden{
  display:none !important
}

.prisma_tables .table-container{
  overflow-y:auto
}

.varsome_table{
  border-collapse:collapse;
  min-width:300px;
  width:initial;
  margin-bottom:0
}

.varsome_table table{
  width:100%
}

.varsome_table tr{
  width:100%
}

.varsome_table th,.varsome_table td{
  box-sizing:border-box;
  padding:10px;
  font-size:12px
}

.varsome_table td{
  border:1px solid #eceeef
}

.varsome_table thead th{
  background:#f5f5f5;
  color:#373a3c;
  text-align:center;
  line-height:1.5em;
  border-bottom:1px solid #3cdbc0;
  font-weight:400
}

.varsome_table tbody{
  text-align:left
}

.varsome_table tbody td{
  font-weight:bold
}

.varsome_table tbody td.font-normal{
  font-weight:normal
}

.varsome_table .numeric{
  text-align:right;
  width:1%;
  white-space:nowrap
}

.varsome_table .center{
  text-align:center
}

.varsome_table .left{
  text-align:left
}

.varsome_table.full-width{
  width:100%
}

.varsome_table tr.highlight td{
  background-color:#dde3ea
}

.varsome_table--reset-bold-td td{
  font-weight:normal !important
}

.varsome_table--stripped-hover tr:hover td{
  background-color:#fff
}

.varsome_table--roboto{
  font-family:"Roboto",sans-serif
}

.varsome_table--td-th-no-wrap td,.varsome_table--td-th-no-wrap th{
  white-space:nowrap
}

.sources_table table{
  position:relative
}

.sources_table td{
  background-color:#f1f0f0
}

.sources_table tr.negative td{
  background-color:#fff
}

.sources_table .fit{
  width:1%;
  white-space:nowrap
}

.sources_table th{
  position:-webkit-sticky;
  position:sticky;
  top:100px;
  z-index:2;
  background-color:#d7e1eb !important
}

.charts-container{
  display:flex;
  flex-wrap:wrap
}

.chart{
  flex:0 0 100%;
  border:1px solid #ddd;
  padding:5px;
  border-radius:4px;
  margin:0px 0 5px;
  position:relative;
  overflow:hidden
}

.chart .chart{
  width:100%;
  height:100%;
  margin:0 !important;
  padding:0;
  flex:1;
  border:none
}

.chart .chart .custom-container{
  width:100%;
  height:100%;
  display:flex;
  align-items:center
}

@media(min-width: 1024px){
  .chart{
    flex:0 0 calc(50% - 5px)
  }

  .chart:nth-of-type(odd){
    margin-right:5px
  }
}

@media(min-width: 1367px){
  .chart{
    padding:10px;
    margin:0px 0 10px;
    flex:0 0 calc(33% - 4px)
  }

  .chart:nth-of-type(odd){
    margin-right:0
  }

  .chart:nth-of-type(3n + 2){
    margin-left:10px;
    margin-right:10px
  }
}

.chart canvas{
  width:100%;
  height:auto;
  display:block
}

.chart--vertical{
  width:100%;
  height:auto
}

.chart--empty{
  width:200px;
  height:160px;
  display:flex;
  justify-content:center;
  flex-direction:column;
  background-color:#f7f7f7;
  padding:0 20px;
  text-align:center;
  margin:0 auto
}

.chart--empty *{
  color:#577396
}

.chart--empty i{
  font-size:1.8rem;
  display:flex;
  justify-content:center;
  color:#577396
}

.chart--empty p{
  padding:1rem 0 0 0;
  color:#577396
}

.chart--empty .emphasize{
  font-weight:600;
  color:#4e6075
}

.chart--premium{
  width:200px;
  height:160px;
  display:flex;
  justify-content:center;
  flex-direction:column;
  background-color:#f7f7f7;
  padding:0 20px;
  text-align:center;
  margin:0 auto
}

.chart--premium *{
  color:#2ca591
}

.chart--premium i{
  font-size:1.8rem;
  display:flex;
  justify-content:center;
  color:#2ca591
}

.chart--premium p{
  padding:1rem 0 0 0;
  color:#000
}

.chart--premium .emphasize{
  font-weight:600;
  color:#000
}

.hidden{
  display:none !important
}

.legend__header .desc{
  font-size:11px;
  font-style:italic;
  margin-left:4px
}

.legend .varsome_table{
  min-width:initial;
  margin-bottom:1.25rem
}

.legend .varsome_table .numeric{
  font-weight:400;
  font-family:"Cabin","Helvetica Neue",Helvetica,Arial,sans-serif
}

.legend .checkbox label{
  margin-bottom:0
}

.saph-green-btn{
  display:inline-block;
  margin-right:8px;
  border-radius:0px;
  cursor:pointer;
  padding-left:24px;
  padding-right:24px;
  padding-top:8px;
  padding-bottom:8px;
  font-weight:500;
  font-size:14px;
  line-height:20px;
  text-decoration:none;
  transition-duration:300ms;
  transition-property:all;
  border-width:1px;
  --border-opacity:1;
  border-color:#2ca591;
  border-color:rgba(44, 165, 145, var(--border-opacity));
  --bg-opacity:1;
  background-color:#2ca591;
  background-color:rgba(44, 165, 145, var(--bg-opacity));
  --text-opacity:1;
  color:#fff;
  color:rgba(255, 255, 255, var(--text-opacity))
}

.saph-green-btn:hover{
  --bg-opacity:1;
  background-color:#35C5AD;
  background-color:rgba(53, 197, 173, var(--bg-opacity));
  --border-opacity:1;
  border-color:#35C5AD;
  border-color:rgba(53, 197, 173, var(--border-opacity))
}

.saph-white-ghost{
  display:inline-block;
  cursor:pointer;
  margin-right:8px;
  margin-bottom:4px;
  border-radius:2px;
  transition-duration:300ms;
  transition-property:all;
  border-width:1px;
  --text-opacity:1;
  color:#fff;
  color:rgba(255, 255, 255, var(--text-opacity));
  --border-opacity:1;
  border-color:#f1f5f9;
  border-color:rgba(241, 245, 249, var(--border-opacity));
  padding-left:4px;
  padding-right:4px;
  padding-top:2px;
  padding-bottom:2px
}

.saph-green-ghost{
  display:inline-block;
  cursor:pointer;
  margin-right:8px;
  border-radius:2px;
  transition-duration:300ms;
  transition-property:all;
  font-size:14px;
  line-height:20px;
  padding:8px;
  border-width:1px;
  --text-opacity:1;
  color:#2ca591;
  color:rgba(44, 165, 145, var(--text-opacity));
  --border-opacity:1;
  border-color:#2ca591;
  border-color:rgba(44, 165, 145, var(--border-opacity))
}

.saph-green-ghost--small{
  display:inline-block;
  cursor:pointer;
  margin-right:4px;
  margin-bottom:4px;
  border-radius:2px;
  transition-duration:300ms;
  transition-property:all;
  font-size:14px;
  line-height:20px;
  padding-left:4px;
  padding-right:4px;
  border-width:1px;
  --text-opacity:1;
  color:#2ca591;
  color:rgba(44, 165, 145, var(--text-opacity));
  --border-opacity:1;
  border-color:#2ca591;
  border-color:rgba(44, 165, 145, var(--border-opacity))
}

.saph-green-ghost--small.active{
  --text-opacity:1;
  color:#fff;
  color:rgba(255, 255, 255, var(--text-opacity));
  --bg-opacity:1;
  background-color:#2ca591;
  background-color:rgba(44, 165, 145, var(--bg-opacity))
}

.saph-combo-button{
  display:inline-block;
  cursor:pointer;
  margin-right:8px;
  --text-opacity:1;
  color:#fff;
  color:rgba(255, 255, 255, var(--text-opacity));
  border-radius:2px;
  font-size:14px;
  line-height:20px;
  padding:0px;
  border-width:1px;
  --border-opacity:1;
  border-color:#f5f5f4;
  border-color:rgba(245, 245, 244, var(--border-opacity))
}

.saph-combo-button>.saph-button{
  margin-right:0px;
  border-style:none;
  border-radius:0px
}

.btn.disabled,.btn:disabled{
  cursor:not-allowed;
  opacity:.45 !important
}

.radiobuttons{
  -webkit-font-smoothing:antialiased;
  -moz-osx-font-smoothing:grayscale
}

.radiobuttons .radiobutton{
  margin:0 0 16px 0
}

.radiobuttons .radiobutton:last-of-type .label{
  padding-right:0
}

.radiobuttons .radiobutton input[type=radio]{
  display:none
}

.radiobuttons .radiobutton input[type=radio]:checked+label:before{
  border-color:#2ca591;
  animation:ripple .2s linear forwards
}

.radiobuttons .radiobutton input[type=radio]:checked+label:after{
  transform:scale(1)
}

.radiobuttons .radiobutton input[type=radio]:disabled+label{
  color:rgba(0,0,0,.42);
  cursor:not-allowed;
  -webkit-user-select:none;
          user-select:none
}

.radiobuttons .radiobutton input[type=radio]:disabled+label:before{
  border-color:rgba(0,0,0,.24)
}

.radiobuttons .radiobutton label{
  display:inline-block;
  height:20px;
  position:relative;
  padding:0 30px;
  margin-bottom:0;
  cursor:pointer;
  vertical-align:bottom
}

.radiobuttons .radiobutton label:before,.radiobuttons .radiobutton label:after{
  position:absolute;
  content:"";
  border-radius:50%;
  transition:all .3s ease;
  transition-property:transform,border-color
}

.radiobuttons .radiobutton label:before{
  left:0;
  top:0;
  width:20px;
  height:20px;
  border:2px solid #9696a0
}

.radiobuttons .radiobutton label:after{
  top:calc(20px/2 - 10px/2);
  left:calc(20px/2 - 10px/2);
  width:10px;
  height:10px;
  transform:scale(0);
  background:#2ca591
}

.radiobuttons .radiobutton .info-text{
  font-size:10px;
  margin:2px 0 0 0;
  font-style:italic;
  line-height:1em;
  -webkit-user-select:none;
          user-select:none
}

.radiobuttons--inline{
  display:inline-flex;
  flex-wrap:wrap;
  margin-right:16px
}

.radiobuttons--inline:last-child{
  margin-right:0
}

.radiobuttons--small .radiobutton{
  margin-bottom:0px
}

.radiobuttons--small .radiobutton label{
  height:14px;
  padding:0px 10px 0px 16px
}

.radiobuttons--small .radiobutton label:before{
  width:14px;
  height:14px;
  border:1px solid #9696a0
}

.radiobuttons--small .radiobutton label:after{
  top:3px;
  left:3px;
  width:8px;
  height:8px
}

@keyframes ripple{
  0%{
    box-shadow:0px 0px 0px 1px rgba(0,0,0,0)
  }

  50%{
    box-shadow:0px 0px 0px 15px rgba(0,0,0,.1)
  }

  100%{
    box-shadow:0px 0px 0px 15px rgba(0,0,0,0)
  }
}

.icon-xxs{
  width:14px;
  height:14px;
  display:inline-block
}

.noselect{
  -webkit-touch-callout:none;
  -webkit-user-select:none;
  user-select:none
}

.saph-pill{
  min-width:200px;
  --text-opacity:1;
  color:#fff;
  color:rgba(255, 255, 255, var(--text-opacity));
  font-weight:600;
  border-radius:24px;
  font-size:16px;
  line-height:24px;
  padding-top:4px;
  padding-bottom:4px;
  padding-left:12px;
  padding-right:12px;
  text-align:center
}

.saph-pill.saph-pill-amp{
  min-width:150px
}

#menu-container .navbar-brand{
  min-height:32px
}

.dropdown.notifications .dot-container{
  width:20px;
  height:20px;
  top:2px;
  left:25px;
  position:absolute
}

.dropdown.notifications .dot{
  background:red;
  box-shadow:0 0 0 0 red;
  transform:scale(1);
  animation:red-pulse 2s 30;
  border-radius:50%;
  height:22px;
  width:22px;
  position:absolute
}

.dropdown.notifications .value{
  position:absolute;
  top:6px;
  left:1px;
  color:#fff;
  font-size:10px;
  text-align:center;
  line-height:1em;
  width:18px;
  font-weight:bold
}

@keyframes red-pulse{
  0%{
    transform:scale(0.95);
    box-shadow:0 0 0 0 rgba(255,0,0,.8)
  }

  70%{
    transform:scale(1);
    box-shadow:0 0 0 10px rgba(255,0,0,0)
  }

  100%{
    transform:scale(0.95);
    box-shadow:0 0 0 0 rgba(255,0,0,0)
  }
}

#profile-page svg.icon{
  width:16px;
  height:16px;
  position:relative;
  top:2px;
  margin-left:2px
}

#profile-page span.label{
  font-size:.95rem;
  color:rgba(55,58,60,.8);
  display:inline-block;
  margin-right:3px
}

#profile-page p.social-link:before{
  content:"|";
  color:#2ca591;
  font-weight:bold;
  margin-left:4px;
  padding-right:4px
}

#profile-page p.social-link:first-of-type:before{
  display:none
}

#page_messages{
  scroll-behavior:smooth;
  max-width:1140px;
  margin:0 auto .9375rem;
  height:calc(100vh - 253px)
}

#page_messages .messages-container{
  font-family:Helvetica,Arial;
  display:flex;
  border:1px solid #e5e5e5;
  height:calc(100% - 35px);
  color:rgba(0,0,0,.9)
}

#page_messages .messages-container .conversations{
  flex:1;
  flex-direction:column;
  align-self:stretch;
  max-width:350px;
  border-right:1px solid #e5e5e5
}

#page_messages .messages-container .conversations__header{
  margin:12px
}

#page_messages .messages-container .conversations__body{
  margin:0;
  padding:0;
  list-style:none;
  overflow-x:hidden;
  overflow-y:auto;
  height:calc(100% - 58px)
}

#page_messages .messages-container .conversation{
  cursor:pointer;
  border-bottom:1px solid #e6e9ec;
  white-space:normal;
  transition-property:color,background-color;
  transition-duration:.1s;
  border-left:2px solid rgba(0,0,0,0);
  padding:8px;
  display:flex;
  position:relative
}

#page_messages .messages-container .conversation:hover{
  background:#f5f5f5;
  color:#000;
  border-left-color:#2ca591
}

#page_messages .messages-container .conversation:last-of-type{
  border-bottom:none
}

#page_messages .messages-container .conversation--selected{
  cursor:default;
  border-left-color:#2ca591;
  background:#f2f2f2
}

#page_messages .messages-container .conversation .primary-info{
  flex:1;
  padding-right:8px
}

#page_messages .messages-container .conversation .message-info{
  display:flex;
  flex:1;
  flex-direction:column
}

#page_messages .messages-container .conversation .avatar-container{
  display:flex;
  justify-content:center;
  align-items:center;
  padding-right:8px
}

#page_messages .messages-container .conversation .avatar-container img{
  width:40px;
  height:40px;
  display:block;
  box-sizing:border-box;
  background-clip:content-box;
  outline:0;
  border-radius:49.9%
}

#page_messages .messages-container .conversation .avatar-container svg{
  width:40px;
  height:40px;
  display:block;
  outline:0;
  border-radius:49.9%;
  border:1px solid #e4e4e4;
  stroke:#676767;
  stroke-width:1px
}

#page_messages .messages-container .conversation .username{
  font-size:14px;
  line-height:1.2em;
  font-weight:700;
  margin:0;
  color:#2ca591
}

#page_messages .messages-container .conversation .organisation{
  font-size:12px;
  line-height:1em;
  font-weight:400;
  margin:0;
  color:#2ca591
}

#page_messages .messages-container .conversation .title{
  line-height:1.2em;
  margin:0;
  font-size:13px;
  color:#000;
  font-weight:400;
  max-width:268px;
  white-space:nowrap;
  overflow:hidden;
  display:inline-block;
  text-overflow:ellipsis
}

#page_messages .messages-container .conversation .title img{
  width:20px;
  height:auto;
  display:inline-block
}

#page_messages .messages-container .conversation .title .emoji{
  display:inline-block;
  width:18px;
  height:18px;
  text-indent:-9999px
}

#page_messages .messages-container .conversation .title p{
  margin-bottom:0;
  display:inline-block
}

#page_messages .messages-container .conversation .date{
  margin:0;
  color:#8993a4;
  font-weight:300;
  font-size:11px
}

#page_messages .messages-container .conversation .status{
  width:18px;
  height:18px;
  background:#012a56;
  border:4px solid #ebecf0;
  border-radius:100%;
  display:block;
  position:absolute;
  top:8px;
  right:8px
}

#page_messages .messages-container .conversation .status.read{
  display:none
}

#page_messages .messages-container .chat-container{
  scroll-behavior:smooth;
  flex:1
}

#page_messages .messages-container .chat-container .chat{
  height:100%
}

#page_messages .messages-container .chat-container .chat.chat--no-reply .chat__body{
  height:calc(100% - 66px)
}

#page_messages .messages-container .chat-container .chat.chat--no-reply .chat__footer{
  box-shadow:none
}

#page_messages .messages-container .chat-container .chat.chat--loading{
  justify-content:center;
  align-items:center;
  display:flex;
  font-size:40px;
  color:#2ca591
}

#page_messages .messages-container .chat-container .chat__header{
  padding:8px;
  display:flex;
  background-color:#577396;
  align-items:center;
  box-shadow:0px 7px 8px -2px rgba(0,0,0,.08)
}

#page_messages .messages-container .chat-container .chat__header .avatar-container{
  display:flex;
  flex:0 0 auto;
  align-items:center
}

#page_messages .messages-container .chat-container .chat__header .avatar-container:hover{
  color:#fff;
  text-decoration:none
}

#page_messages .messages-container .chat-container .chat__header .avatar-container img{
  width:50px;
  height:50px;
  display:block;
  box-sizing:border-box;
  background-clip:content-box;
  outline:0;
  border-radius:49.9%
}

#page_messages .messages-container .chat-container .chat__header .avatar-container svg{
  width:50px;
  height:50px;
  display:block;
  outline:0;
  border-radius:49.9%;
  color:#fff;
  background-color:rgba(255,255,255,.4);
  stroke-width:1
}

#page_messages .messages-container .chat-container .chat__header .avatar-container .username{
  font-size:18px;
  margin:0 0 4px 0;
  font-weight:bold;
  color:#fff
}

#page_messages .messages-container .chat-container .chat__header .avatar-container .organisation{
  font-size:14px;
  line-height:1em;
  font-weight:400;
  margin:0;
  color:#fff
}

#page_messages .messages-container .chat-container .chat__header .actions-container{
  flex:0 0 auto;
  margin-left:auto
}

#page_messages .messages-container .chat-container .chat__body{
  height:calc(100% - 171px);
  overflow-x:hidden;
  overflow-y:auto;
  position:relative
}

#page_messages .messages-container .chat-container .chat__body .message-loading{
  text-align:center;
  padding:5px;
  background-color:rgba(0,0,0,.1);
  color:#2ca591;
  font-size:20px;
  font-weight:bold;
  width:100%;
  position:absolute;
  top:0px;
  left:0;
  z-index:2
}

#page_messages .messages-container .chat-container .chat__body .message{
  display:flex;
  flex-direction:column;
  list-style:none;
  box-sizing:border-box;
  position:relative;
  padding:4px;
  margin:0;
  width:100%;
  margin-bottom:4px;
  transition:background-color .2s
}

#page_messages .messages-container .chat-container .chat__body .message:hover{
  background-color:#f2f2f2
}

#page_messages .messages-container .chat-container .chat__body .message:hover .message_actions{
  opacity:1
}

#page_messages .messages-container .chat-container .chat__body .avatar-container{
  position:absolute;
  left:8px;
  z-index:1
}

#page_messages .messages-container .chat-container .chat__body .avatar-container img{
  width:32px;
  height:32px;
  display:block;
  box-sizing:border-box;
  background-clip:content-box;
  outline:0;
  border-radius:49.9%
}

#page_messages .messages-container .chat-container .chat__body .avatar-container svg{
  width:32px;
  height:32px;
  display:block;
  outline:0;
  border-radius:49.9%;
  color:#676767;
  border:1px solid #e4e4e4;
  stroke-width:1
}

#page_messages .messages-container .chat-container .chat__body .message__meta{
  line-height:1;
  padding:0 0 0 46px
}

#page_messages .messages-container .chat-container .chat__body .username{
  font-size:12px;
  line-height:1.2em;
  font-weight:700;
  color:#2ca591
}

#page_messages .messages-container .chat-container .chat__body .organisation{
  font-size:12px;
  line-height:1em;
  font-weight:400;
  margin:0;
  color:#2ca591
}

#page_messages .messages-container .chat-container .chat__body .timestamp{
  font-size:10px;
  line-height:1em;
  margin-left:4px;
  color:#8993a4
}

#page_messages .messages-container .chat-container .chat__body .message__text{
  margin:0px 0 4px 46px;
  color:rgba(0,0,0,.9);
  word-wrap:break-word;
  white-space:pre-line;
  padding-right:12px;
  font-size:14px;
  line-height:1.4em;
  white-space:pre-wrap;
  word-wrap:break-word;
  word-break:break-all;
  white-space:normal
}

#page_messages .messages-container .chat-container .chat__body .message__text:last-of-type{
  margin-bottom:0
}

#page_messages .messages-container .chat-container .chat__body .message__text img{
  display:inline-block;
  max-width:400px;
  height:auto
}

#page_messages .messages-container .chat-container .chat__body .message__text p{
  margin-bottom:4px
}

#page_messages .messages-container .chat-container .chat__body .message__text p:last-of-type{
  margin-bottom:0
}

#page_messages .messages-container .chat-container .chat__body .message__text p .emoji{
  display:inline-block;
  width:18px;
  height:18px;
  text-indent:-9999px
}

#page_messages .messages-container .chat-container .chat__body .message_actions{
  flex:0 0 auto;
  opacity:0;
  transition:opacity .2s
}

#page_messages .messages-container .chat-container .chat__body .message_actions .report{
  padding:4px;
  cursor:pointer
}

#page_messages .messages-container .chat-container .chat__body .message_actions .report.active{
  opacity:1
}

#page_messages .messages-container .chat-container .chat__body .message_actions .report.active .icon{
  color:#2ca591
}

#page_messages .messages-container .chat-container .chat__body .message_actions .icon{
  display:block;
  width:14px;
  height:14px
}

#page_messages .messages-container .chat-container .chat__body .message_actions.active{
  opacity:1
}

#page_messages .messages-container .chat-container .chat__body .message_actions.active .icon{
  color:#2ca591
}

#page_messages .messages-container .chat-container .chat__footer{
  padding:12px;
  border-top:1px solid #e5e5e5;
  box-shadow:0px -7px 8px -2px rgba(0,0,0,.08);
  position:relative
}

#page_messages .messages-container .chat-container .chat__footer .sticky-pill{
  position:absolute;
  top:-40px;
  left:50%;
  transform:translate(-50%, 0);
  color:#fff;
  background-color:#577396;
  border-radius:8px;
  padding:4px 8px;
  font-size:12px;
  font-weight:bold;
  z-index:2;
  cursor:pointer
}

#page_messages .messages-container .chat-container .chat__footer .message-form{
  display:flex;
  position:relative
}

#page_messages .messages-container .chat-container .chat__footer .textarea{
  display:block;
  resize:none;
  width:100%;
  height:80px;
  padding:.375rem .75rem;
  line-height:1.25;
  color:#4d4d4d;
  background-color:#fff;
  background-clip:padding-box;
  border:1px solid #ccc;
  border-radius:0;
  box-shadow:inset 0 1px 1px rgba(0,0,0,.08);
  outline:none
}

#page_messages .messages-container .chat-container .chat__footer .textarea:disabled{
  cursor:not-allowed;
  -webkit-user-select:none;
          user-select:none
}

#page_messages .messages-container .chat-container .chat__footer .actions-container{
  margin-left:16px;
  min-width:63px;
  display:flex;
  flex-flow:column;
  justify-content:flex-end
}

#page_messages .messages-container .chat-container .chat__footer .actions-container .emoji-trigger{
  display:block;
  width:24px;
  stroke:#2ca591;
  cursor:pointer;
  margin-bottom:4px
}

#page_messages .messages-container .chat-container .chat__footer .emoji-mart{
  position:absolute;
  bottom:60px;
  z-index:5;
  right:0px;
  box-shadow:-4px 4px 11px 4px rgba(0,0,0,.08)
}

#page_messages .messages-container .chat-container .date-container{
  display:flex;
  align-items:center;
  margin:0 16px 0px;
  padding:12px 0;
  text-transform:uppercase;
  letter-spacing:1px;
  clear:both;
  color:#8993a4;
  font-size:10px;
  font-weight:bold
}

#page_messages .messages-container .chat-container .date-container:after,#page_messages .messages-container .chat-container .date-container:before{
  display:block;
  content:"";
  flex-grow:1;
  border-top:1px solid rgba(0,0,0,.15)
}

#page_messages .messages-container .chat-container .date-container:after{
  margin-left:12px
}

#page_messages .messages-container .chat-container .date-container:before{
  margin-right:12px
}

#page_messages .messages-container .search-container{
  position:relative;
  padding:0px
}

#page_messages .messages-container .search-container .input-container{
  position:relative
}

#page_messages .messages-container .search-container .input-container input[type=text]{
  background-color:#fff;
  border:none;
  font-size:14px;
  line-height:1em;
  padding:8px 8px 8px 30px;
  outline:none;
  width:100%;
  border:1px solid #ccc
}

#page_messages .messages-container .search-container .input-container input[type=text]::placeholder{
  color:#8993a4;
  opacity:1
}

#page_messages .messages-container .search-container .input-container input[type=text]:-ms-input-placeholder{
  color:#8993a4
}

#page_messages .messages-container .search-container .input-container input[type=text]::-ms-input-placeholder{
  color:#8993a4
}

#page_messages .messages-container .search-container .input-container svg.icon{
  width:16px;
  height:auto;
  display:block;
  position:absolute;
  left:8px;
  top:8px;
  color:#8993a4
}

#page_messages .messages-container .search-container .results-container{
  margin:12px 0 0;
  width:100%;
  position:absolute;
  top:22px;
  left:0;
  z-index:2
}

#page_messages .messages-container .search-container .results-container .results{
  margin:0;
  padding:0;
  list-style:none;
  background-color:#fafafa;
  max-height:300px;
  overflow-y:auto
}

#page_messages .messages-container .search-container .results-container .result{
  align-items:center;
  padding:8px;
  cursor:pointer;
  background-color:#fafafa;
  border:1px solid #ccc;
  border-top:none;
  transition-property:background-color
}

#page_messages .messages-container .search-container .results-container .result:hover{
  background:#f2f2f2
}

#page_messages .messages-container .search-container .results-container .result__graphic{
  margin-right:8px
}

#page_messages .messages-container .search-container .results-container .result__title{
  font-size:14px;
  line-height:1.2em;
  font-weight:600;
  margin-bottom:0px;
  color:#2ca591
}

#page_messages .messages-container .search-container .results-container .result__subtitle{
  font-size:12px;
  line-height:1em;
  font-weight:400;
  margin-bottom:0px;
  color:#2ca591
}

#page_messages .messages-container .search-container .results-container .result.loading{
  justify-content:center;
  font-size:20px;
  padding:16px;
  color:#2ca591;
  display:flex
}

#page_messages .messages-container .search-container .results-container .result.loading:hover{
  background-color:#fafafa
}

#page_messages .messages-container .search-container .results-container .result.empty{
  justify-content:center;
  font-size:14px;
  padding:16px;
  color:#2ca591;
  display:flex;
  font-weight:600;
  cursor:default
}

#page_messages .messages-container .search-container .results-container .result.empty:hover{
  background-color:#fafafa
}

#page_messages .messages-container .search-container .results-container .graphic{
  width:30px;
  height:30px;
  display:block;
  box-sizing:border-box;
  background-clip:content-box;
  outline:0;
  border-radius:49.9%
}

#page_messages .messages-container .search-container .results-container .graphic--svg{
  width:30px;
  height:30px;
  display:block;
  outline:0;
  border-radius:49.9%;
  border:1px solid #e4e4e4;
  stroke:#676767;
  stroke-width:1px
}

#page_messages .messages-container .filter-container{
  margin:0;
  padding:0;
  list-style:none
}

#page_messages .messages-container .filter-container .filter{
  display:inline-block;
  cursor:pointer;
  font-size:12px;
  padding:4px
}

#page_messages .messages-container .filter-container .filter:hover{
  text-decoration:underline
}

#page_messages .messages-container .filter-container .filter--selected{
  cursor:default;
  color:#2ca591
}

#page_messages .messages-container .filter-container .filter--selected:hover{
  text-decoration:none
}

#page_messages .skeleton-box{
  display:inline-block;
  height:1em;
  position:relative;
  overflow:hidden;
  background-color:#dddbdd;
  border-radius:2px
}

#page_messages .skeleton-box::after{
  position:absolute;
  top:0;
  right:0;
  bottom:0;
  left:0;
  transform:translateX(-100%);
  background-image:linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation:shimmer 2s infinite;
  content:""
}

#page_messages .critical-error{
  text-align:center;
  margin:0;
  top:64px;
  position:relative
}

#page_messages .critical-error .icon{
  display:block;
  width:48px;
  margin:0px auto 16px
}

@keyframes shimmer{
  100%{
    transform:translateX(100%)
  }
}

#page_messages .zoomIn{
  animation-name:zoomIn;
  animation-duration:1s;
  animation-fill-mode:both
}

@keyframes zoomIn{
  0%{
    opacity:0;
    transform:scale3d(0.3, 0.3, 0.3)
  }

  50%{
    opacity:1
  }
}

#page_notifications{
  scroll-behavior:smooth;
  max-width:1140px;
  margin:0 auto
}

#page_notifications .notifications{
  margin:0 0 2.5em;
  padding:0;
  border:1px solid #ddd
}

#page_notifications .dropdown-list__item{
  color:#2ca591;
  padding:12px;
  border-top:1px solid #ddd;
  cursor:pointer;
  white-space:normal;
  transition-property:all;
  transition-duration:.3s;
  display:flex
}

#page_notifications .dropdown-list__item svg{
  width:20px;
  height:20px;
  display:block
}

#page_notifications .dropdown-list__item .title{
  margin:0;
  font-size:13px;
  font-family:Helvetica,Arial
}

#page_notifications .dropdown-list__item .date{
  margin:0;
  color:#8993a4;
  font-weight:600;
  font-size:11px
}

#page_notifications .dropdown-list__item .status{
  content:"NEW";
  display:block;
  font-size:8px;
  margin-left:4px;
  font-weight:bold;
  color:#012a56
}

#page_notifications .dropdown-list__item:hover{
  background:#f5f5f5;
  color:#000
}

#page_notifications .dropdown-list__item:first-of-type{
  border-top:0px
}

#page_notifications .dropdown-list__empty{
  color:#2ca591;
  padding:36px;
  border-bottom:1px solid #ddd;
  font-weight:300;
  text-align:center;
  font-size:14px;
  list-style:none
}

#page_notifications .dropdown-list__empty svg{
  width:32px;
  height:32px;
  display:block;
  margin:0px auto
}

#page_notifications .dropdown-list .primary-info{
  flex:1;
  padding-right:8px
}

#page_notifications .dropdown-list .status{
  flex:0 0 18px;
  width:18px;
  height:18px;
  background:#012a56;
  border:4px solid #ebecf0;
  border-radius:100%;
  display:block
}

#page_notifications .dropdown-list .status.read{
  display:none
}

#page_notifications .skeleton-box{
  display:inline-block;
  height:1em;
  position:relative;
  overflow:hidden;
  background-color:#ececec;
  border-radius:2px
}

#page_notifications .skeleton-box::after{
  position:absolute;
  top:0;
  right:0;
  bottom:0;
  left:0;
  transform:translateX(-100%);
  background-image:linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation:shimmer 2s infinite;
  content:""
}

@keyframes shimmer{
  100%{
    transform:translateX(100%)
  }
}

@media print{
  .no-print,.no-print *{
    display:none !important
  }
}

a.no-underline:hover{
  text-decoration:none
}

.varsome-request-info{
  width:100%;
  max-width:600px;
  padding:1rem 0;
  background-color:#fff;
  border:.1rem solid #e5e5e5;
  text-align:center;
  margin:10% auto
}

.admin-message{
  text-align:center;
  padding:.5rem;
  border:1px solid #bbb;
  margin-bottom:.9375rem
}

.admin-message.normal{
  background-color:#e9ddaf
}

.admin-message.danger{
  background-color:#e69d9d;
  color:#fff
}

.admin-message.info{
  background-color:#81badf
}

.admin-message.dark{
  background-color:rgba(16,16,16,.6);
  color:#fff
}

.admin-message.attention{
  background-color:#2ca591;
  color:#fff
}

.admin-message.banner{
  padding:0
}

.admin-message.banner img{
  width:100%
}

.admin-message.banner p{
  margin:0
}

.admin-message p{
  margin:.25rem 0
}

.research-use-notice{
  position:fixed;
  width:160px;
  z-index:1030;
  top:13px;
  left:calc(50% - 80px);
  padding:.2rem .5rem;
  color:#fff;
  text-align:center
}

.varsome-results{
  margin-top:.9375rem
}

.varsome-results #result-sidebar{
  padding-left:0 !important
}

.help-tour-bg{
  position:fixed;
  top:0;
  left:0;
  width:100%;
  height:100%;
  z-index:100000;
  background-color:rgba(0,0,0,.4);
  border:1px solid #bbb
}

.help-tour-popup{
  position:fixed;
  z-index:100001;
  background-color:#fff;
  padding:1rem;
  margin-top:16px;
  box-shadow:0 0 5px rgba(0,0,0,.6)
}

.help-tour-popup .popup-controls{
  margin-top:2rem;
  padding-top:1rem;
  border-top:1px solid #ccc
}

.help-tour-popup.arrow-top:after,.help-tour-popup.arrow-top:before{
  bottom:100%;
  left:50%;
  border:solid rgba(0,0,0,0);
  content:" ";
  height:0;
  width:0;
  position:absolute;
  pointer-events:none
}

.help-tour-popup.arrow-top:after{
  border-color:rgba(81,110,128,0);
  border-bottom-color:#fff;
  border-width:10px;
  margin-left:-10px
}

.help-tour-popup.arrow-top:before{
  border-color:rgba(194,225,245,0);
  border-bottom-color:#bbb;
  border-width:12px;
  margin-left:-12px
}

.help-tour-popup.arrow-right:after,.help-tour-popup.arrow-right:before{
  bottom:50%;
  right:-24px;
  border:solid rgba(0,0,0,0);
  content:" ";
  height:0;
  width:0;
  position:absolute;
  pointer-events:none
}

.help-tour-popup.arrow-right:after{
  border-color:rgba(81,110,128,0);
  border-left-color:#fff;
  border-width:12px;
  margin-left:-12px
}

.help-tour-popup.arrow-right:before{
  border-color:rgba(194,225,245,0);
  border-left-color:#bbb;
  border-width:12px;
  margin-left:-12px
}

.stop-scrolling{
  height:100%;
  overflow:hidden
}

.split-form-modal label{
  margin-bottom:0
}

.split-form-modal input{
  margin-bottom:.5rem
}

.search-result{
  padding:.4rem 1rem;
  border-top:1px solid #ddd
}

.search-result-label{
  font-size:.7rem;
  font-weight:bold
}

.search-result-matches{
  margin-left:1rem;
  font-size:.9rem
}

.search-result-error{
  color:red;
  margin-left:1rem;
  font-size:.9rem
}

.search-highlight{
  font-weight:bold;
  font-style:italic;
  background-color:#ececec;
  padding:0 4px 0 2px
}

.google-btn{
  display:inline-block;
  margin:0;
  margin-left:1rem;
  font-size:.9rem;
  padding:.1rem .5rem
}

.google-btn:visited{
  color:#3cdbc0
}

.google-btn:hover{
  border-color:#bbb;
  background-color:#fbfbfb
}

.update-log-container p{
  margin-bottom:0
}

.geneInlineIcon{
  width:13px;
  height:13px;
  display:inline-block
}`, "",{"version":3,"sources":["webpack://./src/scss/_form.scss","webpack://./src/scss/_variables.scss","webpack://./src/scss/_sidebar.scss","webpack://./src/scss/_variant-info.scss","webpack://./src/scss/_toasts.scss","webpack://./src/scss/_typeahead.scss","webpack://./src/scss/_pubmed_form.scss","webpack://./src/scss/_charts.scss","webpack://./src/scss/_tables.scss","webpack://./src/scss/_legend.scss","webpack://./src/scss/atoms/_buttons.scss","<no source>","webpack://./src/scss/atoms/_radiobutton.scss","webpack://./src/scss/atoms/_icons.scss","webpack://./src/scss/atoms/_helpers.scss","webpack://./src/scss/atoms/_pill.scss","webpack://./src/scss/sections/_header.scss","webpack://./src/scss/sections/_profile.scss","webpack://./src/scss/sections/_messages.scss","webpack://./src/scss/sections/_notifications.scss","webpack://./src/scss/varsome-style.scss"],"names":[],"mappings":"AAAA;EACI;AAAA;;AAEJ;EACI;AAAA;;AACA;EACI,iBAAA;EACA,WAAA;EACA,SAAA;EACA,2BAAA;EACA,cAAA;EACA;ACFK;;ADGL;EACI;ACRF;;ADYV;EACI,oBAAA;EACA;AAAA;;AEnBJ;EACI,cAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA;AAAA;;AAEJ;EACI,oBAAA;EACA;AAAA;;AACA;EACI;AAAA;;AAGR;EACI,WAAA;EACA,WAAA;EACA,qBAAA;EACA,6BAAA;EACA,4BAAA;EACA;AAAA;;AAGJ;EACI,6BAAA;EACA;AAAA;;AACA;EACI;AAAA;;AAEJ;EACI;AAAA;;AACA;EACI,wBAAA;EACA;AAAA;;ACjCZ;EACE,UAAA;EACA,qCAAA;EACA;AAAA;;AACA;EACE,UAAA;EACA,cAAA;EACA;AAAA;;AAEF;EACE,iBAAA;EACA,oBAAA;EACA;AAAA;;AAIA;EACE,UAAA;EACA;AAAA;;AACA;EACE;AAAA;;AAMR;EACE,4BAAA;EACA,UAAA;EACA,mBAAA;EACA,oBAAA;EACA;AAAA;;AAGF;EACE;AAAA;;AACA;EACE,oBAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EACA;AAAA;;AACA;EACE;AAAA;;AAEF;EACE,cAAA;EACA,aAAA;EACA;AAAA;;AACA;EACE;AAAA;;AAGJ;EACE,UAAA;EACA,iBAAA;EACA,cAAA;EACA,QAAA;EACA;AAAA;;AAGJ;EACE,oBAAA;EACA,iBAAA;EACA,qBAAA;EACA,+DAAA;EACA,UAAA;EACA,kBAAA;EACA,yBAAA;EAEA,cAAA;EACA,qBAAA;EACA;AAAA;;AACA;EACE;AAAA;;AAEF;EACE;AAAA;;AAEF;EACE,UAAA;EACA,eAAA;EACA;AAAA;;AAEF;EACE;AAAA;;AAGJ;EACE,UAAA;EACA,mBAAA;EACA;AAAA;;AACA;EACE,iBAAA;EACA;AAAA;;AAKN;EACE;AAAA;;AACA;EACE,gCAAA;EACA,cAAA;EACA,eAAA;EACA,0BAAA;EACA;AAAA;;AACA;EACE,0BAAA;EACA;AAAA;;AAEF;EACE,2BAAA;EACA,8BAAA;EACA;AAAA;;ACnHN;EACI,cAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA;AAAA;;AAEA;EACI,UAAA;EACA,2BAAA;EACA,UAAA;EACA,oBAAA;EACA,oBAAA;EACA,0CAAA;EACA;AAAA;;AACA;EACI,aAAA;EACA;AAAA;;AAEJ;EACI,SAAA;EACA;AAAA;;AAEJ;EACI,WAAA;EACA;AAAA;;AAEJ;EACI,UAAA;EACA,cAAA;EACA,iBAAA;EACA,SAAA;EACA;AAAA;;AACA;EACI;AAAA;;ACnChB;EACI,iBAAA;EACA;AAAA;;AAEJ;EACI;AAAA;;AAEJ;EACI,qBAAA;EACA,aAAA;EACA,oBAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA;AAAA;;AACA;EACI,mBAAA;EACA;AAAA;;AACA;EACI,wBJhBF;EIiBE;AAAA;;ACrBR;EACI;AAAA;;ACFR;EACE,YAAA;EACA;AAAA;;AAGF;EACE,aAAA;EACA,qBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA;AAAA;;AACA;EACE,UAAA;EACA,WAAA;EACA,mBAAA;EACA,SAAA;EACA,MAAA;EACA;AAAA;;AACA;EACE,UAAA;EACA,WAAA;EACA,YAAA;EACA;AAAA;;AAGJ;EAtBF;IAuBI;EAAA;;EACA;IACE;EAAA;AAAA;;AAGJ;EA5BF;IA6BI,YAAA;IACA,iBAAA;IACA;EAAA;;EACA;IACE;EAAA;;EAEF;IACE,gBAAA;IACA;EAAA;AAAA;;AAIJ;EACE,UAAA;EACA,WAAA;EACA;AAAA;;AAEF;EACE,UAAA;EACA;AAAA;;AAEF;EAIE,WAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,qBAAA;EACA,wBAAA;EACA,cAAA;EACA,iBAAA;EACA;AAAA;;AAXA;EACE;AAAA;;AAWF;EACE,gBAAA;EACA,YAAA;EACA,sBAAA;EACA;AAAA;;AAGF;EACE,kBAAA;EACA;AAAA;;AAEF;EACE,eAAA;EACA;AAAA;;AAGJ;EAIE,WAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,qBAAA;EACA,wBAAA;EACA,cAAA;EACA,iBAAA;EACA;AAAA;;AAXA;EACE;AAAA;;AAWF;EACE,gBAAA;EACA,YAAA;EACA,sBAAA;EACA;AAAA;;AAGF;EACE,kBAAA;EACA;AAAA;;AAEF;EACE,eAAA;EACA;AAAA;;AAIN;EACE;AAAA;;AClHA;EACE;AAAA;;AAIJ;EACE,wBAAA;EACA,eAAA;EACA,aAAA;EACA;AAAA;;AACA;EACE;AAAA;;AAEF;EACE;AAAA;;AAEF;EAEE,qBAAA;EACA,YAAA;EACA;AAAA;;AAEF;EACE;AAAA;;AAGA;EACE,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,+BAAA;EACA;AAAA;;AAGJ;EACE;AAAA;;AACA;EACE;AAAA;;AACA;EACE;AAAA;;AAIN;EACE,gBAAA;EACA,QAAA;EACA;AAAA;;AAEF;EACE;AAAA;;AAEF;EACE;AAAA;;AAEF;EACE;AAAA;;AAGA;EACE;AAAA;;AAIF;EACE;AAAA;;AAKA;EACE;AAAA;;AAIN;EACE;AAAA;;AAGA;EACE;AAAA;;AAMJ;EACE;AAAA;;AAEF;EACE;AAAA;;AAEF;EACE;AAAA;;AAEF;EACE,QAAA;EACA;AAAA;;AAEF;EACE,uBAAA;EAAA,eAAA;EACA,SAAA;EACA,SAAA;EACA;AAAA;;ADxGJ;EACE,YAAA;EACA;AAAA;;AAGF;EACE,aAAA;EACA,qBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA;AAAA;;AACA;EACE,UAAA;EACA,WAAA;EACA,mBAAA;EACA,SAAA;EACA,MAAA;EACA;AAAA;;AACA;EACE,UAAA;EACA,WAAA;EACA,YAAA;EACA;AAAA;;AAGJ;EAtBF;IAuBI;EAAA;;EACA;IACE;EAAA;AAAA;;AAGJ;EA5BF;IA6BI,YAAA;IACA,iBAAA;IACA;EAAA;;EACA;IACE;EAAA;;EAEF;IACE,gBAAA;IACA;EAAA;AAAA;;AAIJ;EACE,UAAA;EACA,WAAA;EACA;AAAA;;AAEF;EACE,UAAA;EACA;AAAA;;AAEF;EAIE,WAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,qBAAA;EACA,wBAAA;EACA,cAAA;EACA,iBAAA;EACA;AAAA;;AAXA;EACE;AAAA;;AAWF;EACE,gBAAA;EACA,YAAA;EACA,sBAAA;EACA;AAAA;;AAGF;EACE,kBAAA;EACA;AAAA;;AAEF;EACE,eAAA;EACA;AAAA;;AAGJ;EAIE,WAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,qBAAA;EACA,wBAAA;EACA,cAAA;EACA,iBAAA;EACA;AAAA;;AAXA;EACE;AAAA;;AAWF;EACE,gBAAA;EACA,YAAA;EACA,sBAAA;EACA;AAAA;;AAGF;EACE,kBAAA;EACA;AAAA;;AAEF;EACE,eAAA;EACA;AAAA;;AAIN;EACE;AAAA;;AEjHM;EACI,cAAA;EACA,iBAAA;EACA;AAAA;;AAGR;EACI,iBAAA;EACA;AAAA;;AACA;EACI,eAAA;EACA;ARoBJ;;AQhBA;EACI;AAAA;;AClBZ;ECAA,qBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,eAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,gBAAA;EAAA,mBAAA;EAAA,gBAAA;EAAA,eAAA;EAAA,iBAAA;EAAA,qBAAA;EAAA,0BAAA;EAAA,wBAAA;EAAA,iBAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,uDAAA;EAAA,eAAA;EAAA,yBAAA;EAAA,uDAAA;EAAA,iBAAA;EAAA,WAAA;EAAA;ADCE;;AAiBF;EClBA,eAAA;EAAA,yBAAA;EAAA,uDAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA;ADmBE;;AAIF;ECvBA,qBAAA;EAAA,eAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,0BAAA;EAAA,wBAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,WAAA;EAAA,+CAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,wDAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA;ADwBE;;AAcF;ECtCA,qBAAA;EAAA,eAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,0BAAA;EAAA,wBAAA;EAAA,eAAA;EAAA,iBAAA;EAAA,YAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,cAAA;EAAA,8CAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA;ADuCE;;AAaF;ECpDA,qBAAA;EAAA,eAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,0BAAA;EAAA,wBAAA;EAAA,eAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,cAAA;EAAA,8CAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA;ADqDE;;AAcF;ECnEA,iBAAA;EAAA,WAAA;EAAA,+CAAA;EAAA,eAAA;EAAA,yBAAA;EAAA;ADoEE;;AAIF;ECxEA,qBAAA;EAAA,eAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,WAAA;EAAA,+CAAA;EAAA,kBAAA;EAAA,eAAA;EAAA,iBAAA;EAAA,YAAA;EAAA,iBAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA;ADyEE;;AAWF;ECpFA,iBAAA;EAAA,kBAAA;EAAA;ADqFE;;AAKF;EAEE,kBAAA;EACA;AAAA;;AEvFF;EACE,kCAAA;EACA;AAAA;;AACA;EACE;AAAA;;AAEE;EACE;AAAA;;AAGJ;EACE;AAAA;;AACA;EACE,oBAnBiB;EAoBjB;AAAA;;AAGF;EACE;AAAA;;AAGA;EACE,qBAAA;EACA,kBAAA;EACA,wBAAA;UAAA;AAAA;;AAEF;EACE;AAAA;;AAKN;EACE,oBAAA;EACA,WAtCU;EAuCV,iBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA;AAAA;;AAEA;EAEE,iBAAA;EACA,UAAA;EACA,iBAAA;EACA,uBAAA;EACA;AAAA;;AAGF;EACE,MAAA;EACA,KAAA;EACA,UAzDQ;EA0DR,WA1DQ;EA2DR;AAAA;;AAGF;EACE,yBAAA;EACA,0BAAA;EACA,UAhEgB;EAiEhB,WAjEgB;EAkEhB,kBAAA;EACA;AAtEiB;;AA0ErB;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,wBAAA;UAAA;AAAA;;AAGJ;EACE,mBAAA;EACA,cAAA;EACA;AAAA;;AACA;EACE;AAAA;;AAIF;EACE;AAAA;;AACA;EACE,WAAA;EACA;AAAA;;AACA;EACE,UAAA;EACA,WAAA;EACA;AAAA;;AAEF;EACE,OAAA;EACA,QAAA;EACA,SAAA;EACA;AAAA;;AAOV;EACE;IACE;EAAA;;EAGF;IACE;EAAA;;EAGF;IACE;EAAA;AAAA;;AC1HJ;EACE,UAAA;EACA,WAAA;EACA;AAAA;;ACHF;EACE,0BAAA;EACE,wBAAA;EAIQ;AAAA;;ACNZ;EACE,eAAA;EJDF,iBAAA;EAAA,WAAA;EAAA,+CAAA;EAAA,gBAAA;EAAA,mBAAA;EAAA,eAAA;EAAA,iBAAA;EAAA,gBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA;AIGE;;AASF;EACE;AAAA;;ACbF;EACE;AAAA;;AAKE;EACE,UAAA;EACA,WAAA;EACA,OAAA;EACA,SAAA;EACA;AAAA;;AAEF;EACE,cAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,WAAA;EACA,UAAA;EACA;AAAA;;AAEF;EACE,iBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,UAAA;EACA;AAAA;;AAKN;EACE;IACE,qBAAA;IACA;EAAA;;EAGF;IACE,kBAAA;IACA;EAAA;;EAGF;IACE,qBAAA;IACA;EAAA;AAAA;;ACjDF;EACE,UAAA;EACA,WAAA;EACA,iBAAA;EACA,OAAA;EACA;AAAA;;AAEF;EACE,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA;AAAA;;AAGA;EACE,WAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA;AAAA;;AAGA;EACE;AAAA;;ACxBR;EACE,sBAAA;EACA,gBAAA;EACA,sBAAA;EACA;AAAA;;AACA;EACE,2BAAA;EACA,YAAA;EACA,wBAAA;EACA,wBAAA;EACA;AAAA;;AACA;EACE,MAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA;AAAA;;AACA;EACE;AAAA;;AAEF;EACE,QAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA;AAAA;;AAGJ;EACE,cAAA;EACA,+BAAA;EACA,kBAAA;EACA,0CAAA;EACA,uBAAA;EACA,mCAAA;EACA,WAAA;EACA,YAAA;EACA;AAAA;;AACA;EACE,kBAAA;EACA,UAAA;EACA;AAAA;;AAEF;EACE;AAAA;;AAEF;EACE,cAAA;EACA,yBAAA;EACA;AAAA;;AAEF;EACE,MAAA;EACA;AAAA;;AAEF;EACE,YAAA;EACA,MAAA;EACA;AAAA;;AAEF;EACE,YAAA;EACA,sBAAA;EACA,kBAAA;EACA;AAAA;;AACA;EACE,UAAA;EACA,WAAA;EACA,aAAA;EACA,qBAAA;EACA,2BAAA;EACA,SAAA;EACA;AAAA;;AAEF;EACE,UAAA;EACA,WAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;EACA,wBAAA;EACA,cAAA;EACA;AAAA;;AAGJ;EACE,cAAA;EACA,iBAAA;EACA,eAAA;EACA,QAAA;EACA;AAAA;;AAEF;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,QAAA;EACA;AAAA;;AAEF;EACE,iBAAA;EACA,QAAA;EACA,cAAA;EACA,UAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA;AAAA;;AACA;EACE,UAAA;EACA,WAAA;EACA;AAAA;;AAEF;EACE,oBAAA;EACA,UAAA;EACA,WAAA;EACA;AAAA;;AAEF;EACE,eAAA;EACA;AAAA;;AAGJ;EACE,QAAA;EACA,aAAA;EACA,eAAA;EACA;AAAA;;AAEF;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,wBAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,OAAA;EACA;AAAA;;AACA;EACE;AAAA;;AAIN;EACE,sBAAA;EACA;AAAA;;AACA;EACE;AAAA;;AAGI;EACE;AAAA;;AAEF;EACE;AAAA;;AAIN;EACE,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA;AAAA;;AAGJ;EACE,WAAA;EACA,YAAA;EACA,wBAAA;EACA,kBAAA;EACA;AAAA;;AACA;EACE,YAAA;EACA,aAAA;EACA;AAAA;;AACA;EACE,UAAA;EACA;AAAA;;AAEF;EACE,UAAA;EACA,WAAA;EACA,aAAA;EACA,qBAAA;EACA,2BAAA;EACA,SAAA;EACA;AAAA;;AAEF;EACE,UAAA;EACA,WAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;EACA,UAAA;EACA,qCAAA;EACA;AAAA;;AAEF;EACE,cAAA;EACA,gBAAA;EACA,gBAAA;EACA;AAAA;;AAEF;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,QAAA;EACA;AAAA;;AAGJ;EACE,aAAA;EACA;AAAA;;AAGJ;EACE,yBAAA;EACA,iBAAA;EACA,eAAA;EACA;AAAA;;AACA;EACE,iBAAA;EACA,WAAA;EACA,+BAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,UAAA;EACA,iBAAA;EACA,OAAA;EACA,MAAA;EACA;AAAA;;AAEF;EACE,YAAA;EACA,qBAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;EACA,WAAA;EACA,QAAA;EACA,UAAA;EACA,iBAAA;EACA;AAAA;;AACA;EACE;AAAA;;AACA;EACE;AAAA;;AAIN;EACE,iBAAA;EACA,QAAA;EACA;AAAA;;AACA;EACE,UAAA;EACA,WAAA;EACA,aAAA;EACA,qBAAA;EACA,2BAAA;EACA,SAAA;EACA;AAAA;;AAEF;EACE,UAAA;EACA,WAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;EACA,wBAAA;EACA;AAAA;;AAGJ;EACE,aAAA;EACA;AAAA;;AAEF;EACE,cAAA;EACA,iBAAA;EACA,eAAA;EACA;AAAA;;AAEF;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,QAAA;EACA;AAAA;;AAEF;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA;AAAA;;AAEF;EACE,qBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA;AAAA;;AACA;EACE;AAAA;;AAEF;EACE,oBAAA;EACA,eAAA;EACA;AAAA;;AAEF;EACE;AAAA;;AACA;EACE;AAAA;;AAEF;EACE,oBAAA;EACA,UAAA;EACA,WAAA;EACA;AAAA;;AAIN;EACE,aAAA;EACA,SAAA;EACA;AAAA;;AACA;EACE,WAAA;EACA;AAAA;;AACA;EACE;AAAA;;AACA;EACE;AAAA;;AAIN;EACE,aAAA;EACA,UAAA;EACA;AAAA;;AAEF;EACE;AAAA;;AACA;EACE;AAAA;;AAKR;EACE,YAAA;EACA,4BAAA;EACA,4CAAA;EACA;AAAA;;AACA;EACE,iBAAA;EACA,SAAA;EACA,QAAA;EACA,4BAAA;EACA,UAAA;EACA,wBAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;EACA;AAAA;;AAEF;EACE,YAAA;EACA;AAAA;;AAEF;EACE,aAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,2BAAA;EACA,qBAAA;EACA,eAAA;EACA,0CAAA;EACA;AAAA;;AACA;EACE,kBAAA;EACA,wBAAA;UAAA;AAAA;;AAGJ;EACE,gBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA;AAAA;;AACA;EACE,aAAA;EACA,UAAA;EACA,cAAA;EACA,cAAA;EACA;AAAA;;AAGJ;EACE,iBAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;EACA;AAAA;;AAGJ;EACE,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,wBAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,cAAA;EACA;AAAA;;AACA;EAEE,aAAA;EACA,UAAA;EACA,WAAA;EACA;AAAA;;AAEF;EACE;AAAA;;AAEF;EACE;AAAA;;AAIN;EACE,iBAAA;EACA;AAAA;;AACA;EACE;AAAA;;AACA;EACE,qBAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,wBAAA;EACA,YAAA;EACA,UAAA;EACA;AAAA;;AACA;EAEE,aAAA;EACA;AAAA;;AAGF;EAEE;AAAA;;AAGF;EAEE;AAAA;;AAGJ;EACE,UAAA;EACA,WAAA;EACA,aAAA;EACA,iBAAA;EACA,QAAA;EACA,OAAA;EACA;AAAA;;AAGJ;EACE,eAAA;EACA,UAAA;EACA,iBAAA;EACA,QAAA;EACA,MAAA;EACA;AAAA;;AACA;EACE,QAAA;EACA,SAAA;EACA,eAAA;EACA,wBAAA;EACA,gBAAA;EACA;AAAA;;AAEF;EACE,kBAAA;EACA,WAAA;EACA,cAAA;EACA,wBAAA;EACA,qBAAA;EACA,eAAA;EACA;AAAA;;AACA;EACE;AAAA;;AAEF;EACE;AAAA;;AAEF;EACE,cAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA;AAAA;;AAEF;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA;AAAA;;AAEF;EACE,sBAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA;AAAA;;AACA;EACE;AAAA;;AAGJ;EACE,sBAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA;AAAA;;AACA;EACE;AAAA;;AAIN;EACE,UAAA;EACA,WAAA;EACA,aAAA;EACA,qBAAA;EACA,2BAAA;EACA,SAAA;EACA;AAAA;;AACA;EACE,UAAA;EACA,WAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;EACA,wBAAA;EACA,cAAA;EACA;AAAA;;AAKR;EACE,QAAA;EACA,SAAA;EACA;AAAA;;AACA;EACE,oBAAA;EACA,cAAA;EACA,cAAA;EACA;AAAA;;AACA;EACE;AAAA;;AAEF;EACE,cAAA;EACA;AAAA;;AACA;EACE;AAAA;;AAMV;EACE,oBAAA;EACA,UAAA;EACA,iBAAA;EACA,eAAA;EACA,wBAAA;EACA;AAAA;;AACA;EACE,iBAAA;EACA,KAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,2BAAA;EACA,qJAAA;EAOA,6BAAA;EACA;AAAA;;AAIJ;EACE,iBAAA;EACA,QAAA;EACA,QAAA;EACA;AAAA;;AACA;EACE,aAAA;EACA,UAAA;EACA;AAAA;;AAGJ;EACE;IACE;EAAA;AAAA;;AAGJ;EACE,qBAAA;EACA,qBAAA;EACA;AAAA;;AAEF;EACE;IACE,SAAA;IAEA;EAAA;;EAEF;IACE;EAAA;AAAA;;ACnpBN;EACE,sBAAA;EACA,gBAAA;EACA;AAAA;;AACA;EACE,gBAAA;EACA,SAAA;EACA;AAAA;;AAGA;EACE,aAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,uBAAA;EACA;AAAA;;AACA;EACE,UAAA;EACA,WAAA;EACA;AAAA;;AAEF;EACE,QAAA;EACA,cAAA;EACA;AAAA;;AAEF;EACE,QAAA;EACA,aAAA;EACA,eAAA;EACA;AAAA;;AAEF;EACE,aAAA;EACA,aAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA;AAAA;;AAEF;EACE,kBAAA;EACA;AAAA;;AAEF;EACE;AAAA;;AAGJ;EACE,aAAA;EACA,YAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA;AAAA;;AACA;EACE,UAAA;EACA,WAAA;EACA,aAAA;EACA;AAAA;;AAGJ;EACE,MAAA;EACA;AAAA;;AAEF;EACE,aAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,wBAAA;EACA,kBAAA;EACA;AAAA;;AACA;EACE;AAAA;;AAIN;EACE,oBAAA;EACA,UAAA;EACA,iBAAA;EACA,eAAA;EACA,wBAAA;EACA;AAAA;;AACA;EACE,iBAAA;EACA,KAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,2BAAA;EACA,qJAAA;EAOA,6BAAA;EACA;AAAA;;AAGJ;EACE;IACE;EAAA;AAAA;;AC/FN;EACE;IAEE;EAAA;AAAA;;AAIJ;EACE;AAAA;;AAGF;EACE,UAAA;EACA,eAAA;EACA,cAAA;EACA,qBAAA;EACA,0BnB/BO;EmBgCP,iBAAA;EACA;AAAA;;AAGF;EACE,iBAAA;EACA,aAAA;EACA,qBAAA;EACA;AAAA;;AACA;EACE;AAAA;;AAEF;EACE,wBnBvCK;EmBwCL;AAAA;;AAEF;EACE;AAAA;;AAEF;EACE,kCAAA;EACA;AAAA;;AAEF;EACE,wBAAA;EACA;AAAA;;AAEF;EACE;AAAA;;AACA;EACE;AAAA;;AAEF;EACE;AAAA;;AAGJ;EACE;AAAA;;AAIJ;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;EACA,UAAA;EACA;AAAA;;AAGF;EAEE;AAAA;;AAGF;EACE;AAAA;;AAGF;EACE,cAAA;EACA,KAAA;EACA,MAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;EACA,+BAAA;EACA;AAAA;;AAEF;EACE,cAAA;EACA,cAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;EACA;AAAA;;AACA;EACE,eAAA;EACA,gBAAA;EACA;AAAA;;AAIJ;EAEE,WAAA;EACA,QAAA;EACA,0BAAA;EACA,WAAA;EACA,QAAA;EACA,OAAA;EACA,iBAAA;EACA;AAAA;;AAEF;EACE,+BAAA;EACA,wBAAA;EACA,iBAAA;EACA;AAAA;;AAEF;EACE,gCAAA;EACA,wBAAA;EACA,iBAAA;EACA;AAAA;;AAGF;EAEE,UAAA;EACA,WAAA;EACA,0BAAA;EACA,WAAA;EACA,QAAA;EACA,OAAA;EACA,iBAAA;EACA;AAAA;;AAEF;EACE,+BAAA;EACA,sBAAA;EACA,iBAAA;EACA;AAAA;;AAEF;EACE,gCAAA;EACA,sBAAA;EACA,iBAAA;EACA;AAAA;;AAGF;EACE,WAAA;EACA;AAAA;;AAIA;EACE;AAAA;;AAEF;EACE;AAAA;;AAIJ;EACE,kBAAA;EACA;AAAA;;AAEF;EACE,eAAA;EACA;AAAA;;AAEF;EACE,gBAAA;EACA;AAAA;;AAEF;EACE,SAAA;EACA,gBAAA;EACA;AAAA;;AAEF;EACE,gBAAA;EACA,iBAAA;EACA,wBAAA;EACA;AAAA;;AAEF;EACE,oBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA;AAAA;;AACA;EACE;AnB5MM;;AmB8MR;EACE,iBAAA;EACA;AAAA;;AAIJ;EACE;AAAA;;AAGF;EACE,UAAA;EACA,WAAA;EACA;AAAA","sourcesContent":[".search-container{\n    padding-top: 0.5rem;\n}\n.results-search-form{\n    position: relative;\n    .clear-btn{\n        position: absolute;\n        right: .7rem;\n        top: .4rem;\n        font-size: 1.2rem !important;\n        cursor: pointer;\n        color: $text-muted;\n        &:hover{\n            color: $success;\n        }\n    }\n}\n.search-form-examples{\n    display: inline-block;\n    padding: 0.5rem 0;\n}\n","$border: 0.1rem solid #e5e5e5;\n\n$bg-title: #f5f5f5;\n$primary: #2ca591;\n$primary-h: #3cdbc0;\n$success: #3cdbc0;\n$danger: #e69d9d;\n$green: #1c9868;\n$text: #373a3c;\n$text-muted: #818a91;\n\n$purple: rgb(76, 29, 149);\n$green: rgb(5, 150, 105);\n$orange: rgb(180, 83, 9);\n$red: rgb(220, 38, 38);\n$blue: rgb(30, 58, 138);\n$sky: #4b74c4;\n\n$pathogenic-very-strong: #c70700ff;\n$pathogenic-strong: #d93115ff;\n$pathogenic-moderate: #eb5b2b;\n$pathogenic-supporting: #fd8540;\n$uncertain: #ffab45ff;\n$benigh-very-strong: #076418;\n$benigh-strong: #258831;\n$benigh-moderate: #50a838;\n$benigh-supporting: #73c36f;\n$badges-label: #ffffff;\n$unknown-pathogenicity-color: #9a9ada;\n\n$table-top-border: 1px solid rgb(236, 238, 239);\n\n$raleway: \"Raleway\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$cabin: \"Cabin\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$cutive: \"Cutive Mono\", \"Menlo\", \"Monaco\", \"Consolas\", \"Courier New\";\n$helvetica: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$roboto: \"Roboto\", \"Arimo\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n",".mobile-sidebar-container{\n    position: fixed;\n    top: 53px;\n    z-index: 1080;\n    right: -180px;\n    transition: right 0.2s ease-in;\n}\n.mobile-sidebar-trigger{\n    display: inline-block;\n    padding: 3px 8px;\n    i.varsome-icons{\n        color: #fff;\n    }\n}\n.mobile-sidebar{\n    width: 180px;\n    height: 100%;\n    background-color: #fff;\n    border-left: 1px solid $success;\n    border-top: 1px solid $success;\n    overflow-y: scroll;\n}\n\n.sidebar-link{\n    padding-left: 0.7rem !important;\n    padding-right: 0.5rem !important;\n    .tag{\n        margin-top: 3px;\n    }\n    &.sidebar-gene-link{\n        color: $primary !important;\n        &:hover{\n            color: $primary-h !important;\n            text-decoration: underline;\n        }\n    }\n}\n","#variant-info {\n  width: 100%;\n  background-color: rgba(90, 122, 160, 0.85);\n  position: relative;\n  .mark-as-text {\n    color: #fff;\n    font-size: 1rem;\n    margin-right: 0.5rem;\n  }\n  .tag-pill {\n    margin-left: 0.2rem;\n    margin-right: -0.8rem;\n    padding-left: 0.2rem;\n  }\n\n  .ctas-container__app {\n    .saph-white-ghost {\n      opacity: 0.9;\n      padding: 4px;\n      &:hover {\n        opacity: 1;\n      }\n    }\n  }\n}\n\n.tooltip-section-top {\n  border-bottom: 1px solid #999;\n  color: #fff;\n  margin-bottom: 0.2rem;\n  padding-bottom: 0.2rem;\n  display: block;\n}\n\n.result-chooser {\n  display: table-cell;\n  .grouped-variants {\n    display: inline-block;\n    position: relative;\n    border: 1px dashed #fff;\n    padding: 0.2rem 0.5rem;\n    margin: -0.4rem 1rem 0.5rem 0;\n    vertical-align: middle;\n    &.last {\n      margin-right: 0;\n    }\n    a {\n      font-size: 16px;\n      display: block;\n      padding: 0 0.3rem;\n      &:first-child {\n        margin-bottom: 2px;\n      }\n    }\n    .grouped-info {\n      color: #fff;\n      position: absolute;\n      font-size: 14px;\n      top: -3px;\n      right: -16px;\n    }\n  }\n  a {\n    display: inline-block;\n    text-align: center;\n    vertical-align: middle;\n    font-family: \"Cabin\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    color: #ccc;\n    padding: 0 1rem 0 0;\n    font-size: 16px !important;\n    // font-size: 22px;\n    cursor: pointer;\n    vertical-align: middle;\n    height: 100%;\n    &.single-variant {\n      margin-bottom: 0.5rem;\n    }\n    &:hover {\n      color: #fff;\n    }\n    &.selected {\n      color: #fff;\n      font-weight: 900;\n      cursor: default;\n    }\n    &.last {\n      padding-right: 0;\n    }\n  }\n  .transcript-tooltip {\n    color: #fff;\n    margin-left: -0.8rem;\n    margin-right: 0.8rem;\n    &.last {\n      margin-left: 0.2rem;\n      margin-right: 0;\n    }\n  }\n}\n\n.btn-group {\n  vertical-align: middle;\n  .btn-action {\n    padding: 0.25rem 1rem 0.25rem 0.5rem;\n    margin-right: 0;\n    border-radius: 0;\n    border-left: 1px solid #fff;\n    border-right: 1px solid #fff;\n    &:first-child {\n      border-top-left-radius: 3px;\n      border-bottom-left-radius: 3px;\n    }\n    &:last-child {\n      border-top-right-radius: 3px;\n      border-bottom-right-radius: 3px;\n      margin-right: 1rem;\n    }\n  }\n}\n",".toast-container{\n    position: fixed;\n    width: 15rem;\n    max-width: 300px;\n    bottom: 1rem;\n    right: 1rem;\n    z-index: 10101;\n\n    .toast{\n        width: 100%;\n        padding: 1rem 2rem 1rem 1rem;\n        color: white;\n        margin-bottom: 0.75rem;\n        opacity: 1!important;\n        background-color: rgba(0, 0, 0, 0.8)!important;\n        position: relative;\n        i.fa-info-circle{\n            color: #729FFF;\n            margin-right: 0.5rem;\n        }\n        i.fa-exclamation-circle{\n            color: red;\n            margin-right: 0.5rem;\n        }\n        i.fa-check{\n            color: green;\n            margin-right: 0.5rem;\n        }\n        .closeBtn{\n            color: white;\n            cursor: pointer;\n            position: absolute;\n            top: 0.5rem;\n            right: 0.5rem;\n            &:hover{\n                color: #AAA;\n            }\n        }\n    }\n}\n",".varsome-typeahead{\n    position: relative;\n    width: 100%;\n}\n.varsome-typeahead-input{\n    width: inherit;\n}\n.varsome-typeahead-results{\n    background-color: #fff;\n    z-index: 10001;\n    list-style-type: none;\n    max-width: 500px;\n    margin: 0;\n    padding: 0;\n    max-height: 240px;\n    overflow-y: auto;\n    border: 1px solid #CCC;\n    li{\n        padding: .1rem .3rem;\n        cursor: pointer;\n        &.selected{\n            background-color: $success;\n            color: #fff;\n        }\n    }\n}",".pubmed-form{\n    .pubmed-form-error{\n        margin: 1rem 0 2rem 0;\n    }\n}\n",".charts-container{\n  display:flex;\n  flex-wrap: wrap;\n}\n\n.chart {\n  flex: 0 0 100%;\n  border: 1px solid #dddddd;\n  padding: 5px;\n  border-radius: 4px;\n  margin: 0px 0 5px;\n  position: relative;\n  overflow: hidden;\n  .chart {\n    width:100%;\n    height:100%;\n    margin: 0 !important;\n    padding: 0;\n    flex: 1;\n    border: none;\n    .custom-container{\n      width: 100%;\n      height: 100%;\n      display: flex;\n      align-items: center;\n    }\n  }\n  @media (min-width: 1024px) {\n    flex: 0 0 calc(50% - 5px);\n    &:nth-of-type(odd) {\n      margin-right: 5px;\n    }\n  }\n  @media (min-width: 1367px) {\n    padding: 10px;\n    margin: 0px 0 10px;\n    flex: 0 0 calc(33% - 4px);\n    &:nth-of-type(odd) {\n      margin-right: 0;\n    }\n    &:nth-of-type(3n + 2) {\n      margin-left: 10px;\n      margin-right: 10px;\n    }\n  }\n\n  canvas {\n    width: 100%;\n    height: auto;\n    display: block;\n  }\n  &--vertical {\n    width: 100%;\n    height: auto;\n  }\n  &--empty{\n    & *{\n      color:#577396;\n    }\n    width: 200px;\n    height: 160px;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    background-color: #f7f7f7;\n    padding: 0 20px;\n    text-align: center;\n    margin: 0 auto;\n    i{\n      font-size: 1.8rem;\n      display: flex;\n      justify-content: center;\n      color:#577396;\n      \n    }\n    p{\n      padding: 1rem 0 0 0;\n      color:#577396;\n    }\n    .emphasize{\n      font-weight:600;\n      color:#4e6075;\n    }\n  }\n  &--premium{\n    & *{\n      color:#2ca591;\n    }\n    width: 200px;\n    height: 160px;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    background-color: #f7f7f7;\n    padding: 0 20px;\n    text-align: center;\n    margin: 0 auto;\n    i{\n      font-size: 1.8rem;\n      display: flex;\n      justify-content: center;\n      color:#2ca591;\n      \n    }\n    p{\n      padding: 1rem 0 0 0;\n      color:#000000;\n    }\n    .emphasize{\n      font-weight:600;\n      color:#000000;\n    }\n  }\n}\n.hidden {\n  display: none !important;\n}",".prisma_tables {\n  .table-container {\n    overflow-y: auto;\n  }\n}\n\n.varsome_table {\n  border-collapse: collapse;\n  min-width: 300px;\n  width: initial;\n  margin-bottom: 0;\n  table {\n    width: 100%;\n  }\n  tr {\n    width: 100%;\n  }\n  th,\n  td {\n    box-sizing: border-box;\n    padding: 10px;\n    font-size: 12px;\n  }\n  td {\n    border: 1px solid #eceeef;\n  }\n  thead {\n    th {\n      background: #f5f5f5;\n      color: #373a3c;\n      text-align: center;\n      line-height: 1.5em;\n      border-bottom: 1px solid #3cdbc0;\n      font-weight: 400;\n    }\n  }\n  tbody {\n    text-align: left;\n    td {\n      font-weight: bold;\n      &.font-normal{\n        font-weight:normal;\n      }\n    }\n  }\n  .numeric {\n    text-align: right;\n    width: 1%;\n    white-space: nowrap;\n  }\n  .center{\n    text-align: center;\n  }\n  .left{\n    text-align: left;\n  }\n  &.full-width{\n    width:100%;\n  }\n  tr{\n    &.highlight td{\n      background-color: #dde3ea;\n    }\n  }\n  &--reset-bold-td{\n    td{\n      font-weight:normal !important;\n    }\n  }\n  &--stripped-hover{\n    tr:hover{\n      td{\n        background-color:white;\n      }\n    }\n  }\n  &--roboto{\n    font-family:\"Roboto\", sans-serif;\n  }\n  &--td-th-no-wrap{\n    td,th{\n      white-space: nowrap;\n    }\n  }\n}\n\n.sources_table{\n  table{\n    position:relative;\n  }\n  td{\n    background-color:#f1f0f0;\n  }\n  tr.negative td{\n    background-color:#FFF;\n  }\n  .fit{\n    width: 1%;\n    white-space: nowrap;\n  }\n  th {\n    position: sticky;\n    top: 100px;\n    z-index: 2;\n    background-color:#d7e1eb !important;\n  }\n}\n",".legend{\n    &__header{\n        .desc{\n            font-size:11px;\n            font-style: italic;\n            margin-left:4px;\n        }\n    }\n    .varsome_table{\n        min-width:initial;\n        margin-bottom:1.25rem;\n        .numeric{\n            font-weight:400;\n            font-family: $cabin;\n        }\n    }\n    .checkbox{\n        label{\n            margin-bottom:0;\n        }\n    }\n}",".saph-green-btn {\n  @apply tw-inline-block\n    tw-mr-2\n    tw-rounded-none\n    tw-cursor-pointer\n    tw-px-6\n    tw-py-2\n    tw-font-medium\n    tw-text-sm\n    tw-no-underline\n    tw-duration-300\n    tw-transition-all\n    tw-border\n    tw-border-primary\n    tw-bg-primary\n    tw-text-white;\n}\n\n.saph-green-btn:hover {\n  @apply tw-bg-primaryLighter\n  tw-border-primaryLighter;\n}\n\n.saph-white-ghost {\n  @apply tw-inline-block\n  tw-cursor-pointer\n  tw-mr-2\n  tw-mb-1\n  tw-rounded-sm\n  tw-duration-300\n  tw-transition-all\n  tw-border\n  tw-text-white\n  tw-border-blueGray-100\n  tw-px-1\n  tw-py-0.5;\n}\n\n.saph-green-ghost {\n  @apply tw-inline-block\n  tw-cursor-pointer\n  tw-mr-2\n  tw-rounded-sm\n  tw-duration-300\n  tw-transition-all\n  tw-text-sm\n  tw-p-2\n  tw-border\n  tw-text-primary\n  tw-border-primary;\n}\n\n.saph-green-ghost--small {\n  @apply tw-inline-block\n  tw-cursor-pointer\n  tw-mr-1\n  tw-mb-1\n  tw-rounded-sm\n  tw-duration-300\n  tw-transition-all\n  tw-text-sm\n  tw-px-1\n  tw-border\n  tw-text-primary\n  tw-border-primary;\n}\n\n.saph-green-ghost--small.active {\n  @apply tw-text-white\n  tw-bg-primary;\n}\n\n.saph-combo-button {\n  @apply tw-inline-block\n  tw-cursor-pointer\n  tw-mr-2\n  tw-text-white\n  tw-rounded-sm\n  tw-text-sm\n  tw-p-0\n  tw-border\n  tw-border-warmGray-100;\n}\n\n.saph-combo-button > .saph-button {\n  @apply tw-mr-0\n  tw-border-none\n  tw-rounded-none;\n}\n\n.btn.disabled,\n.btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.45 !important;\n}\n",null,"$md-radio-checked-color: #2ca591;\n$md-radio-border-color: rgba(150, 150, 160, 1);\n$md-radio-size: 20px;\n$md-radio-checked-size: 10px;\n$md-radio-ripple-size: 15px;\n\n.radiobuttons {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  .radiobutton {\n    margin: 0 0 16px 0;\n    &:last-of-type {\n      .label{\n        padding-right: 0;\n      }\n    }\n    input[type=\"radio\"] {\n      display: none;\n      &:checked + label:before {\n        border-color: $md-radio-checked-color;\n        animation: ripple 0.2s linear forwards;\n      }\n\n      &:checked + label:after {\n        transform: scale(1);\n      }\n      &:disabled {\n        & + label {\n          color: rgba(0, 0, 0, 0.42);\n          cursor: not-allowed;\n          user-select: none;\n        }\n        & + label:before {\n          border-color: rgba(0, 0, 0, 0.24);\n        }\n      }\n    }\n\n    label {\n      display: inline-block;\n      height: $md-radio-size;\n      position: relative;\n      padding: 0 ($md-radio-size + 10px);\n      margin-bottom: 0;\n      cursor: pointer;\n      vertical-align: bottom;\n      \n      &:before,\n      &:after {\n        position: absolute;\n        content: \"\";\n        border-radius: 50%;\n        transition: all 0.3s ease;\n        transition-property: transform, border-color;\n      }\n\n      &:before {\n        left: 0;\n        top: 0;\n        width: $md-radio-size;\n        height: $md-radio-size;\n        border: 2px solid $md-radio-border-color;\n      }\n\n      &:after {\n        top: calc(#{$md-radio-size} / 2 - #{$md-radio-checked-size} / 2);\n        left: calc(#{$md-radio-size} / 2 - #{$md-radio-checked-size} / 2);\n        width: $md-radio-checked-size;\n        height: $md-radio-checked-size;\n        transform: scale(0);\n        background: $md-radio-checked-color;\n      }\n    }\n\n    .info-text {\n      font-size: 10px;\n      margin: 2px 0 0 0;\n      font-style: italic;\n      line-height: 1em;\n      user-select: none;\n    }\n  }\n  &--inline {\n    display: inline-flex;\n    flex-wrap: wrap;\n    margin-right: 16px;\n    &:last-child {\n      margin-right: 0;\n    }\n  }\n  &--small {\n    .radiobutton {\n      margin-bottom: 0px;\n      label {\n        height: 14px;\n        padding: 0px 10px 0px 16px;\n        &:before {\n          width: 14px;\n          height: 14px;\n          border: 1px solid $md-radio-border-color;\n        }\n        &:after {\n          top: 3px;\n          left: 3px;\n          width: 8px;\n          height: 8px;\n        }\n      }\n    }\n  }\n}\n\n@keyframes ripple {\n  0% {\n    box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0);\n  }\n\n  50% {\n    box-shadow: 0px 0px 0px $md-radio-ripple-size rgba(0, 0, 0, 0.1);\n  }\n\n  100% {\n    box-shadow: 0px 0px 0px $md-radio-ripple-size rgba(0, 0, 0, 0);\n  }\n}\n",".icon-xxs{\n  width:14px;\n  height:14px;\n  display:inline-block;\n}",".noselect {\n  -webkit-touch-callout: none; /* iOS Safari */\n    -webkit-user-select: none; /* Safari */\n     -khtml-user-select: none; /* Konqueror HTML */\n       -moz-user-select: none; /* Old versions of Firefox */\n        -ms-user-select: none; /* Internet Explorer/Edge */\n            user-select: none; /* Non-prefixed version, currently\n                                  supported by Chrome, Edge, Opera and Firefox */\n}",".saph-pill{\n  min-width:200px;\n  @apply\n  tw-text-white \n  tw-font-semibold \n  tw-rounded-3xl \n  tw-text-base \n  tw-py-1 \n  tw-px-3 \n  tw-text-center\n}\n\n.saph-pill.saph-pill-amp{\n  min-width:150px;\n}","#menu-container .navbar-brand{\n  min-height:32px;\n}\n\n.dropdown {\n  &.notifications {\n    .dot-container {\n      width: 20px;\n      height: 20px;\n      top: 2px;\n      left: 25px;\n      position: absolute;\n    }\n    .dot {\n      background: rgba(255, 0, 0, 1);\n      box-shadow: 0 0 0 0 rgba(255, 0, 0, 1);\n      transform: scale(1);\n      animation: red-pulse 2s 30; // keep it to one minute - just it causes style recalcs.\n      border-radius: 50%;\n      height: 22px;\n      width: 22px;\n      position: absolute;\n    }\n    .value {\n      position: absolute;\n      top: 6px;\n      left: 1px;\n      color: #fff;\n      font-size: 10px;\n      text-align: center;\n      line-height: 1em;\n      width: 18px;\n      font-weight: bold;\n    }\n  }\n}\n\n@keyframes red-pulse {\n  0% {\n    transform: scale(0.95);\n    box-shadow: 0 0 0 0 rgba(255, 0, 0, 0.8);\n  }\n\n  70% {\n    transform: scale(1);\n    box-shadow: 0 0 0 10px rgba(255, 0, 0, 0);\n  }\n\n  100% {\n    transform: scale(0.95);\n    box-shadow: 0 0 0 0 rgba(255, 0, 0, 0);\n  }\n}\n","#profile-page{\n  svg.icon{\n    width:16px;\n    height:16px;\n    position:relative;\n    top:2px;\n    margin-left:2px;\n  }\n  span.label{\n    font-size:0.95rem;\n    color:rgba(55,58,60,0.8);\n    display:inline-block;\n    margin-right:3px;\n  }\n  p.social-link{\n    &:before{\n      content: \"|\";\n      color:#2ca591;\n      font-weight:bold;\n      margin-left: 4px;\n      padding-right: 4px;\n    }\n    &:first-of-type{\n      &:before{\n        display:none;\n      }\n    }\n  }\n}","#page_messages {\n  scroll-behavior: smooth;\n  max-width: 1140px;\n  margin: 0 auto 0.9375rem;\n  height: calc(100vh - 253px);\n  .messages-container {\n    font-family: Helvetica, Arial;\n    display: flex;\n    border: 1px solid #e5e5e5;\n    height: calc(100% - 35px);\n    color: rgba(0, 0, 0, 0.9);\n    .conversations {\n      flex: 1;\n      flex-direction: column;\n      align-self: stretch;\n      max-width: 350px;\n      border-right: 1px solid #e5e5e5;\n      &__header {\n        margin: 12px;\n      }\n      &__body {\n        margin: 0;\n        padding: 0;\n        list-style: none;\n        overflow-x: hidden;\n        overflow-y: auto;\n        height: calc(100% - 58px);\n      }\n    }\n    .conversation {\n      cursor: pointer;\n      border-bottom: 1px solid #e6e9ec;\n      white-space: normal;\n      transition-property: color, background-color;\n      transition-duration: 0.1s;\n      border-left: 2px solid transparent;\n      padding: 8px;\n      display: flex;\n      position: relative;\n      &:hover {\n        background: #f5f5f5;\n        color: #000;\n        border-left-color: #2ca591;\n      }\n      &:last-of-type {\n        border-bottom: none;\n      }\n      &--selected {\n        cursor: default;\n        border-left-color: #2ca591;\n        background: #f2f2f2;\n      }\n      .primary-info {\n        flex: 1;\n        padding-right: 8px;\n      }\n      .message-info {\n        display: flex;\n        flex: 1;\n        flex-direction: column;\n      }\n      .avatar-container {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        padding-right: 8px;\n        img {\n          width: 40px;\n          height: 40px;\n          display: block;\n          box-sizing: border-box;\n          background-clip: content-box;\n          outline: 0;\n          border-radius: 49.9%;\n        }\n        svg {\n          width: 40px;\n          height: 40px;\n          display: block;\n          outline: 0;\n          border-radius: 49.9%;\n          border: 1px solid #e4e4e4;\n          stroke: #676767;\n          stroke-width: 1px;\n        }\n      }\n      .username {\n        font-size: 14px;\n        line-height: 1.2em;\n        font-weight: 700;\n        margin: 0;\n        color: #2ca591;\n      }\n      .organisation {\n        font-size: 12px;\n        line-height: 1em;\n        font-weight: 400;\n        margin: 0;\n        color: #2ca591;\n      }\n      .title {\n        line-height: 1.2em;\n        margin: 0;\n        font-size: 13px;\n        color: #000;\n        font-weight: 400;\n        max-width: 268px;\n        white-space: nowrap;\n        overflow: hidden;\n        display: inline-block;\n        text-overflow: ellipsis;\n        img {\n          width:20px;\n          height:auto;\n          display: inline-block;\n        }\n        .emoji {\n          display: inline-block;\n          width: 18px;\n          height: 18px;\n          text-indent: -9999px;\n        }\n        p {\n          margin-bottom: 0;\n          display: inline-block;\n        }\n      }\n      .date {\n        margin: 0;\n        color: #8993a4;\n        font-weight: 300;\n        font-size: 11px;\n      }\n      .status {\n        width: 18px;\n        height: 18px;\n        background: #012a56;\n        border: 4px solid #ebecf0;\n        border-radius: 100%;\n        display: block;\n        position: absolute;\n        top: 8px;\n        right: 8px;\n        &.read {\n          display: none;\n        }\n      }\n    }\n    .chat-container {\n      scroll-behavior: smooth;\n      flex: 1;\n      .chat {\n        height: 100%;\n        &.chat--no-reply {\n          .chat {\n            &__body {\n              height: calc(100% - 66px);\n            }\n            &__footer {\n              box-shadow: none;\n            }\n          }\n        }\n        &.chat--loading {\n          justify-content: center;\n          align-items: center;\n          display: flex;\n          font-size: 40px;\n          color: #2ca591;\n        }\n      }\n      .chat__header {\n        padding: 8px;\n        display: flex;\n        background-color: #577396;\n        align-items: center;\n        box-shadow: 0px 7px 8px -2px rgba(0, 0, 0, 0.08);\n        .avatar-container {\n          display: flex;\n          flex: 0 0 auto;\n          align-items: center;\n          &:hover {\n            color: #fff;\n            text-decoration: none;\n          }\n          img {\n            width: 50px;\n            height: 50px;\n            display: block;\n            box-sizing: border-box;\n            background-clip: content-box;\n            outline: 0;\n            border-radius: 49.9%;\n          }\n          svg {\n            width: 50px;\n            height: 50px;\n            display: block;\n            outline: 0;\n            border-radius: 49.9%;\n            color: #fff;\n            background-color: rgba(255, 255, 255, 0.4);\n            stroke-width: 1;\n          }\n          .username {\n            font-size: 18px;\n            margin: 0 0 4px 0;\n            font-weight: bold;\n            color: #fff;\n          }\n          .organisation {\n            font-size: 14px;\n            line-height: 1em;\n            font-weight: 400;\n            margin: 0;\n            color: #fff;\n          }\n        }\n        .actions-container {\n          flex: 0 0 auto;\n          margin-left: auto;\n        }\n      }\n      .chat__body {\n        height: calc(100% - 171px);\n        overflow-x: hidden;\n        overflow-y: auto;\n        position: relative;\n        .message-loading {\n          text-align: center;\n          padding: 5px;\n          background-color: rgba(0, 0, 0, 0.1);\n          color: #2ca591;\n          font-size: 20px;\n          font-weight: bold;\n          width: 100%;\n          position: absolute;\n          top: 0px;\n          left: 0;\n          z-index: 2;\n        }\n        .message {\n          display: flex;\n          flex-direction: column;\n          list-style: none;\n          box-sizing: border-box;\n          position: relative;\n          padding: 4px;\n          margin: 0;\n          width: 100%;\n          margin-bottom: 4px;\n          transition: background-color 0.2s;\n          &:hover {\n            background-color: #f2f2f2;\n            .message_actions{\n              opacity:1;\n            }\n          }\n        }\n        .avatar-container {\n          position: absolute;\n          left: 8px;\n          z-index: 1;\n          img {\n            width: 32px;\n            height: 32px;\n            display: block;\n            box-sizing: border-box;\n            background-clip: content-box;\n            outline: 0;\n            border-radius: 49.9%;\n          }\n          svg {\n            width: 32px;\n            height: 32px;\n            display: block;\n            outline: 0;\n            border-radius: 49.9%;\n            color: #676767;\n            border: 1px solid #e4e4e4;\n            stroke-width: 1;\n          }\n        }\n        .message__meta {\n          line-height: 1;\n          padding: 0 0 0 46px;\n        }\n        .username {\n          font-size: 12px;\n          line-height: 1.2em;\n          font-weight: 700;\n          color: #2ca591;\n        }\n        .organisation {\n          font-size: 12px;\n          line-height: 1em;\n          font-weight: 400;\n          margin: 0;\n          color: #2ca591;\n        }\n        .timestamp {\n          font-size: 10px;\n          line-height: 1em;\n          margin-left: 4px;\n          color: #8993a4;\n        }\n        .message__text {\n          margin: 0px 0 4px 46px;\n          color: rgba(0, 0, 0, 0.9);\n          word-wrap: break-word;\n          white-space: pre-line;\n          padding-right: 12px;\n          font-size: 14px;\n          line-height: 1.4em;\n          white-space: pre-wrap;\n          word-wrap: break-word;\n          word-break: break-all;\n          white-space: normal;\n          &:last-of-type {\n            margin-bottom: 0;\n          }\n          img{\n            display: inline-block;\n            max-width: 400px;\n            height: auto;\n          }\n          p {\n            margin-bottom: 4px;\n            &:last-of-type {\n              margin-bottom: 0;\n            }\n            .emoji {\n              display: inline-block;\n              width: 18px;\n              height: 18px;\n              text-indent: -9999px;\n            }\n          }\n        }\n        .message_actions{\n          flex:0 0 auto;\n          opacity:0;\n          transition: opacity 0.2s;\n          .report{\n            padding:4px;\n            cursor: pointer;  \n            &.active{\n              opacity:1;\n              .icon{\n                color:#2ca591;\n              }\n            }\n          }\n          .icon{\n            display:block;\n            width:14px;\n            height:14px;\n          }\n          &.active{\n            opacity:1;\n            .icon{\n              color:#2ca591;\n            }\n          }\n        }\n      }\n      .chat__footer {\n        padding: 12px;\n        border-top: 1px solid #e5e5e5;\n        box-shadow: 0px -7px 8px -2px rgba(0, 0, 0, 0.08);\n        position: relative;\n        .sticky-pill {\n          position: absolute;\n          top: -40px;\n          left: 50%;\n          transform: translate(-50%, 0);\n          color: #fff;\n          background-color: #577396;\n          border-radius: 8px;\n          padding: 4px 8px;\n          font-size: 12px;\n          font-weight: bold;\n          z-index: 2;\n          cursor: pointer;\n        }\n        .message-form {\n          display: flex;\n          position: relative;\n        }\n        .textarea {\n          display: block;\n          resize: none;\n          width: 100%;\n          height: 80px;\n          padding: 0.375rem 0.75rem;\n          line-height: 1.25;\n          color: #4d4d4d;\n          background-color: #fff;\n          background-clip: padding-box;\n          border: 1px solid #ccc;\n          border-radius: 0;\n          box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.08);\n          outline: none;\n          &:disabled {\n            cursor: not-allowed;\n            user-select: none;\n          }\n        }\n        .actions-container {\n          margin-left: 16px;\n          min-width: 63px;\n          display: flex;\n          flex-flow: column;\n          justify-content: flex-end;\n          .emoji-trigger {\n            display: block;\n            width: 24px;\n            stroke: #2ca591;\n            cursor: pointer;\n            margin-bottom: 4px;\n          }\n        }\n        .emoji-mart {\n          position: absolute;\n          bottom: 60px;\n          z-index: 5;\n          right: 0px;\n          box-shadow: -4px 4px 11px 4px rgba(0, 0, 0, 0.08);\n        }\n      }\n      .date-container {\n        display: flex;\n        align-items: center;\n        margin: 0 16px 0px;\n        padding: 12px 0;\n        text-transform: uppercase;\n        letter-spacing: 1px;\n        clear: both;\n        color: #8993a4;\n        font-size: 10px;\n        font-weight: bold;\n        &:after,\n        &:before {\n          display: block;\n          content: \"\";\n          flex-grow: 1;\n          border-top: 1px solid rgba(0, 0, 0, 0.15);\n        }\n        &:after {\n          margin-left: 12px;\n        }\n        &:before {\n          margin-right: 12px;\n        }\n      }\n    }\n    .search-container {\n      position: relative;\n      padding: 0px;\n      .input-container {\n        position: relative;\n        input[type=\"text\"] {\n          background-color: white;\n          border: none;\n          font-size: 14px;\n          line-height: 1em;\n          padding: 8px 8px 8px 30px;\n          outline: none;\n          width: 100%;\n          border: 1px solid #ccc;\n          &::placeholder {\n            /* Chrome, Firefox, Opera, Safari 10.1+ */\n            color: #8993a4;\n            opacity: 1; /* Firefox */\n          }\n\n          &:-ms-input-placeholder {\n            /* Internet Explorer 10-11 */\n            color: #8993a4;\n          }\n\n          &::-ms-input-placeholder {\n            /* Microsoft Edge */\n            color: #8993a4;\n          }\n        }\n        svg.icon {\n          width: 16px;\n          height: auto;\n          display: block;\n          position: absolute;\n          left: 8px;\n          top: 8px;\n          color: #8993a4;\n        }\n      }\n      .results-container {\n        margin: 12px 0 0;\n        width: 100%;\n        position: absolute;\n        top: 22px;\n        left: 0;\n        z-index: 2;\n        .results {\n          margin: 0;\n          padding: 0;\n          list-style: none;\n          background-color: #fafafa;\n          max-height: 300px;\n          overflow-y: auto;\n        }\n        .result {\n          align-items: center;\n          padding: 8px;\n          cursor: pointer;\n          background-color: #fafafa;\n          border: 1px solid #ccc;\n          border-top: none;\n          transition-property: background-color;\n          &:hover {\n            background: #f2f2f2;\n          }\n          &__graphic {\n            margin-right: 8px;\n          }\n          &__title {\n            font-size: 14px;\n            line-height: 1.2em;\n            font-weight: 600;\n            margin-bottom: 0px;\n            color: #2ca591;\n          }\n          &__subtitle {\n            font-size: 12px;\n            line-height: 1em;\n            font-weight: 400;\n            margin-bottom: 0px;\n            color: #2ca591;\n          }\n          &.loading {\n            justify-content: center;\n            font-size: 20px;\n            padding: 16px;\n            color: #2ca591;\n            display: flex;\n            &:hover {\n              background-color: #fafafa;\n            }\n          }\n          &.empty {\n            justify-content: center;\n            font-size: 14px;\n            padding: 16px;\n            color: #2ca591;\n            display: flex;\n            font-weight: 600;\n            cursor: default;\n            &:hover {\n              background-color: #fafafa;\n            }\n          }\n        }\n        .graphic {\n          width: 30px;\n          height: 30px;\n          display: block;\n          box-sizing: border-box;\n          background-clip: content-box;\n          outline: 0;\n          border-radius: 49.9%;\n          &--svg {\n            width: 30px;\n            height: 30px;\n            display: block;\n            outline: 0;\n            border-radius: 49.9%;\n            border: 1px solid #e4e4e4;\n            stroke: #676767;\n            stroke-width: 1px;\n          }\n        }\n      }\n    }\n    .filter-container {\n      margin: 0;\n      padding: 0;\n      list-style: none;\n      .filter {\n        display: inline-block;\n        cursor: pointer;\n        font-size: 12px;\n        padding: 4px;\n        &:hover {\n          text-decoration: underline;\n        }\n        &--selected {\n          cursor: default;\n          color: #2ca591;\n          &:hover {\n            text-decoration: none;\n          }\n        }\n      }\n    }\n  }\n  .skeleton-box {\n    display: inline-block;\n    height: 1em;\n    position: relative;\n    overflow: hidden;\n    background-color: #dddbdd;\n    border-radius: 2px;\n    &::after {\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      transform: translateX(-100%);\n      background-image: linear-gradient(\n        90deg,\n        rgba(#fff, 0) 0,\n        rgba(#fff, 0.2) 20%,\n        rgba(#fff, 0.5) 60%,\n        rgba(#fff, 0)\n      );\n      animation: shimmer 2s infinite;\n      content: \"\";\n    }\n  }\n\n  .critical-error {\n    text-align: center;\n    margin:0;\n    top: 64px;\n    position: relative;\n    .icon {\n      display: block;\n      width: 48px;\n      margin: 0px auto 16px;\n    }\n  }\n  @keyframes shimmer {\n    100% {\n      transform: translateX(100%);\n    }\n  }\n  .zoomIn {\n    animation-name: zoomIn;\n    animation-duration: 1s;\n    animation-fill-mode: both;\n  }\n  @keyframes zoomIn {\n    0% {\n      opacity: 0;\n      -webkit-transform: scale3d(0.3, 0.3, 0.3);\n      transform: scale3d(0.3, 0.3, 0.3);\n    }\n    50% {\n      opacity: 1;\n    }\n  }\n}\n","#page_notifications {\n  scroll-behavior: smooth;\n  max-width: 1140px;\n  margin: 0 auto;\n  .notifications {\n    margin:0 0 2.5em;\n    padding: 0;\n    border: 1px solid #ddd;\n  }\n  .dropdown-list {\n    &__item {\n      color: #2ca591;\n      padding: 12px;\n      border-top: 1px solid #ddd;\n      cursor: pointer;\n      white-space: normal;\n      transition-property: all;\n      transition-duration: 0.3s;\n      display: flex;\n      svg{\n        width: 20px;\n        height: 20px;\n        display: block;\n      }\n      .title {\n        margin: 0;\n        font-size: 13px;\n        font-family: Helvetica, Arial;\n      }\n      .date {\n        margin: 0;\n        color: #8993a4;\n        font-weight: 600;\n        font-size: 11px;\n      }\n      .status{\n        content:\"NEW\";\n        display: block;\n        font-size:8px;\n        margin-left:4px;\n        font-weight:bold;\n        color:#012a56;\n      }\n      &:hover {\n        background: #f5f5f5;\n        color: #000;\n      }\n      &:first-of-type {\n        border-top:0px;\n      }\n    }\n    &__empty {\n      color: #2ca591;\n      padding: 36px;\n      border-bottom: 1px solid #ddd;\n      font-weight: 300;\n      text-align: center;\n      font-size: 14px;\n      list-style: none;\n      svg {\n        width: 32px;\n        height: 32px;\n        display: block;\n        margin: 0px auto;\n      }\n    }\n    .primary-info {\n      flex: 1;\n      padding-right: 8px;\n    }\n    .status {\n      flex: 0 0 18px;\n      width: 18px;\n      height: 18px;\n      background: #012a56;\n      border: 4px solid #ebecf0;\n      border-radius: 100%;\n      display: block;\n      &.read {\n        display: none;\n      }\n    }\n  }\n  .skeleton-box {\n    display: inline-block;\n    height: 1em;\n    position: relative;\n    overflow: hidden;\n    background-color: #ececec;\n    border-radius: 2px;\n    &::after {\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      transform: translateX(-100%);\n      background-image: linear-gradient(\n        90deg,\n        rgba(#fff, 0) 0,\n        rgba(#fff, 0.2) 20%,\n        rgba(#fff, 0.5) 60%,\n        rgba(#fff, 0)\n      );\n      animation: shimmer 2s infinite;\n      content: '';\n    }\n  }\n  @keyframes shimmer {\n    100% {\n      transform: translateX(100%);\n    }\n  }\n}\n","@import \"variables\";\n@import \"form\";\n@import \"sidebar\";\n@import \"variant-info\";\n@import \"toasts\";\n@import \"typeahead\";\n@import \"pubmed_form\";\n@import \"charts\";\n@import \"tables\";\n@import \"charts\";\n@import \"legend\";\n@import \"atoms/atoms\";\n@import \"sections/sections\";\n@import \"tooltip\";\n\n@media print {\n  .no-print,\n  .no-print * {\n    display: none !important;\n  }\n}\n\na.no-underline:hover {\n  text-decoration: none;\n}\n\n.varsome-request-info {\n  width: 100%;\n  max-width: 600px;\n  padding: 1rem 0;\n  background-color: #fff;\n  border: $border;\n  text-align: center;\n  margin: 10% auto;\n}\n\n.admin-message {\n  text-align: center;\n  padding: 0.5rem;\n  border: 1px solid #bbb;\n  margin-bottom: 0.9375rem;\n  &.normal {\n    background-color: #e9ddaf;\n  }\n  &.danger {\n    background-color: $danger;\n    color: #fff;\n  }\n  &.info {\n    background-color: #81badf;\n  }\n  &.dark {\n    background-color: rgba(16, 16, 16, 0.6);\n    color: #fff;\n  }\n  &.attention {\n    background-color: #2ca591;\n    color: #fff;\n  }\n  &.banner {\n    padding: 0;\n    img {\n      width: 100%;\n    }\n    p {\n      margin: 0;\n    }\n  }\n  p {\n    margin: 0.25rem 0;\n  }\n}\n\n.research-use-notice {\n  position: fixed;\n  width: 160px;\n  z-index: 1030;\n  top: 13px;\n  left: calc(50% - 80px);\n  padding: 0.2rem 0.5rem;\n  color: #fff;\n  text-align: center;\n}\n\n.varsome-results {\n  //margin-top: 20px;\n  margin-top: 0.9375rem;\n}\n\n.varsome-results #result-sidebar {\n  padding-left: 0 !important;\n}\n\n.help-tour-bg {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 100000;\n  background-color: rgba(0, 0, 0, 0.4);\n  border: 1px solid #bbb;\n}\n.help-tour-popup {\n  position: fixed;\n  z-index: 100001;\n  background-color: #fff;\n  padding: 1rem;\n  margin-top: 16px;\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.6);\n  .popup-controls {\n    margin-top: 2rem;\n    padding-top: 1rem;\n    border-top: 1px solid #ccc;\n  }\n}\n\n.help-tour-popup.arrow-top:after,\n.help-tour-popup.arrow-top:before {\n  bottom: 100%;\n  left: 50%;\n  border: solid transparent;\n  content: \" \";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none;\n}\n.help-tour-popup.arrow-top:after {\n  border-color: rgba(81, 110, 128, 0);\n  border-bottom-color: #fff;\n  border-width: 10px;\n  margin-left: -10px;\n}\n.help-tour-popup.arrow-top:before {\n  border-color: rgba(194, 225, 245, 0);\n  border-bottom-color: #bbb;\n  border-width: 12px;\n  margin-left: -12px;\n}\n\n.help-tour-popup.arrow-right:after,\n.help-tour-popup.arrow-right:before {\n  bottom: 50%;\n  right: -24px;\n  border: solid transparent;\n  content: \" \";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none;\n}\n.help-tour-popup.arrow-right:after {\n  border-color: rgba(81, 110, 128, 0);\n  border-left-color: #fff;\n  border-width: 12px;\n  margin-left: -12px;\n}\n.help-tour-popup.arrow-right:before {\n  border-color: rgba(194, 225, 245, 0);\n  border-left-color: #bbb;\n  border-width: 12px;\n  margin-left: -12px;\n}\n\n.stop-scrolling {\n  height: 100%;\n  overflow: hidden;\n}\n\n.split-form-modal {\n  label {\n    margin-bottom: 0;\n  }\n  input {\n    margin-bottom: 0.5rem;\n  }\n}\n\n.search-result {\n  padding: 0.4rem 1rem;\n  border-top: 1px solid #ddd;\n}\n.search-result-label {\n  font-size: 0.7rem;\n  font-weight: bold;\n}\n.search-result-matches {\n  margin-left: 1rem;\n  font-size: 0.9rem;\n}\n.search-result-error {\n  color: red;\n  margin-left: 1rem;\n  font-size: 0.9rem;\n}\n.search-highlight {\n  font-weight: bold;\n  font-style: italic;\n  background-color: #ececec;\n  padding: 0 4px 0 2px;\n}\n.google-btn {\n  display: inline-block;\n  margin: 0;\n  margin-left: 1rem;\n  font-size: 0.9rem;\n  padding: 0.1rem 0.5rem;\n  &:visited {\n    color: $success;\n  }\n  &:hover {\n    border-color: #bbb;\n    background-color: #fbfbfb;\n  }\n}\n\n.update-log-container p {\n  margin-bottom: 0;\n}\n\n.geneInlineIcon {\n  width: 13px;\n  height: 13px;\n  display: inline-block;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
